export const fr = {
  shell: {
    help: 'Aide et support',
    helpWhatsapp: 'WhatsApp',
    helpWhatsappHint: 'Écrivez à notre équipe',
    helpGuides: 'Guides vidéo',
    helpGuidesHint: 'Un guide par écran',
    helpCenter: 'Centre d’aide',
    helpCenterHint: 'Articles et questions fréquentes',
    searching: 'Recherche…',
    orderResult: '{{number}} · {{customer}}',
    ordersFound: 'Commandes',
    appName: 'Al-WidadiaShop',
    search: 'Rechercher une commande, un produit…',
    searchPlaceholder: 'Commande, produit, client, page…',
    commands: 'Commandes rapides',
    noResults: 'Aucun résultat',
    userMenu: 'Menu utilisateur',
    tenant: 'Boutique',
    badge_ordersToConfirm_one: '{{label}}, {{count}} commande à confirmer',
    badge_ordersToConfirm_other: '{{label}}, {{count}} commandes à confirmer',
    badge_missingParcels_one: '{{label}}, {{count}} colis manquant',
    badge_missingParcels_other: '{{label}}, {{count}} colis manquants',
    switchTenant: 'Changer de boutique',
    switchTenantConfirm: 'Changer',
    logout: 'Se déconnecter',
    login: 'Se connecter',
    loggingIn: 'Redirection vers la connexion…',
    checkingSession: 'Vérification de votre session…',
    openingWorkspace: 'Préparation de votre espace…',
    stepSession: 'Session',
    stepSignIn: 'Connexion',
    stepWorkspace: 'Espace de travail',
    secureSignIn: 'Connexion unique sécurisée',
    menu: 'Menu',
    collapse: 'Réduire le menu',
    expand: 'Déplier le menu',
    loading: 'Chargement',
    loginFailedTitle: 'Connexion impossible',
    callbackFailed: 'La session n’a pas pu être finalisée. Revenez à l’accueil et reconnectez-vous.',
    loginFailed: 'La connexion a échoué. Réessayez dans quelques instants.',
    signInTitle: 'Bon retour parmi nous',
    signInDescription: 'Connectez-vous avec votre compte Al-WidadiaShop pour ouvrir votre espace.',
    sessionExpiredTitle: 'Votre session a expiré',
    sessionExpiredDescription:
      'Par sécurité, vous avez été déconnecté après une période d’inactivité. Reconnectez-vous pour reprendre là où vous en étiez.',
    insecureContext: 'L’authentification exige une connexion sécurisée. Ouvrez l’application en HTTPS.',
    forbidden: 'Vous n’avez pas accès à cette page.',
    backHome: 'Retour au tableau de bord',
    language: 'Langue',
    theme: 'Thème',
    theme_light: 'Clair',
    theme_dark: 'Sombre',
    toggleTheme: 'Passer au thème {{theme}}',
    theme_system: 'Système',
    density: 'Densité',
    density_comfortable: 'Confortable',
    density_compact: 'Compacte',
    density_spacious: 'Spacieuse',
    densityHint_compact: 'Plus d’informations à l’écran',
    densityHint_comfortable: 'Équilibrée',
    densityHint_spacious: 'Plus d’espace, plus lisible',
  },
  nav: {
    statistics: 'Statistiques',
    statistics_delivery: 'Livraison',
    statistics_confirmation: 'Confirmation',
    statistics_products: 'Produits',
    statistics_orders: 'Commandes',
    statistics_marketing: 'Marketing',
    calculator: 'Calculateur',
    labels: 'Étiquettes',
    financeOverview: 'Vue d’ensemble',
    remittances: 'Relevés transporteurs',
    disputes: 'Litiges',
    expenses: 'Dépenses',
    handoverShort: 'Remise',
    group_sales: 'Ventes',
    group_logistics: 'Logistique',
    group_catalog: 'Catalogue',
    handover: 'Remise transporteur',
    returns: 'Retours',
    returnedParcels: 'Retournés',
    missingParcels: 'Manquants',
    finance: 'Finance',
    dashboard: 'Tableau de bord',
    orders: 'Commandes',
    products: 'Produits',
    settings: 'Paramètres',
    categories: 'Catégories',
    inventory: 'Stock',
    tenants: 'Boutiques',
    customers: 'Clients',
    history: 'Historique des modifications',
    newOrder: 'Nouvelle commande',
  },
  dashboard: {
    filters: {
      product: 'Produit',
      allProducts: 'Tous les produits',
      findProduct: 'Chercher un produit (nom ou référence)',
      noProductMatch: 'Aucun produit trouvé',
      origin: 'Provenance',
      allOrigins: 'Toutes provenances',
      allImported: 'Importé (tous pays)',
      shopWideHidden:
        'Charges et bénéfice net concernent toute la boutique : ils sont masqués quand un produit ou une provenance est choisi.',
    },
    greeting: 'Bonjour {{name}}',
    openOrders: 'Voir les commandes',
    newOrder: 'Nouvelle commande',
    newProduct: 'Ajouter un produit',
    points: '{{value}} pts',
    deltaLabel: '{{value}} par rapport à la période précédente',
    noOrdersTitle: 'Aucune commande sur cette période',
    noOrdersDescription:
      'Les ventes, les livraisons et les retours apparaîtront ici dès la première commande.',
    seeInventory: 'Voir le stock',
    urgentNoneHelp: 'Aucun article n’est sous son seuil de stock bas.',
    urgentNone: 'Rien à réapprovisionner',
    urgentOut: 'En rupture',
    urgentThreshold: 'Seuil : {{count}}',
    urgentLeft: 'Reste : {{count}}',
    urgentTitle: 'À réapprovisionner',
    noDepotsHelp: 'Créez un dépôt dans Stock pour suivre vos quantités.',
    noDepots: 'Aucun dépôt actif',
    valueMissing: 'Articles en stock sans prix d’achat : {{count}}. La valeur affichée est sous-estimée.',
    value: 'Valeur',
    out: 'Rupture',
    low: 'Stock bas',
    reserved: 'Réservé',
    available: 'Disponible',
    inStock: 'Articles en stock',
    depot: 'Dépôt',
    depotsTitle: 'Stock par dépôt',
    stockValue: 'Valeur du stock (au prix d’achat)',
    outOfStock: 'Articles en rupture',
    toRestock: 'À réapprovisionner',
    availableUnits: 'Unités disponibles',
    stockContext: 'Le stock actuel, dépôt par dépôt, et les articles à réapprovisionner.',
    title: 'Tableau de bord',
    context: 'Activité, résultat et stock de la boutique',
    activeProducts: 'Produits actifs',
    pendingMovements: 'Mouvements en attente',
    emptyTitle: 'Pas encore de produits',
    emptyDescription: 'Créez un premier produit pour voir vos indicateurs se remplir.',
    performanceTitle: 'Activité de la période',
    created: 'Commandes créées',
    delivered: 'Commandes livrées',
    deliveryRate: 'Taux de livraison',
    returned: 'Retours',
    canceled: 'Annulées',
    sales: 'Ventes livrées',
    grossMargin: 'Marge brute',
    net: 'Résultat net',
    recentTitle: 'Commandes créées',
    recentLabel_one: 'Commandes créées le dernier jour',
    recentLabel_other: 'Commandes créées par jour sur les {{count}} derniers jours',
    recentDays_one: '{{count}} j',
    recentDays_other: '{{count}} j',
    parcelsTitle: 'Colis en cours',
    parcelsTotal_one: '{{total}} colis chez les transporteurs',
    parcelsTotal_other: '{{total}} colis chez les transporteurs',
    parcelsNone: 'Aucun colis chez les transporteurs',
    parcelsNoneHelp: 'Les colis expédiés apparaissent ici jusqu’à leur livraison ou leur retour.',
    awaitingConfirmation_one: '{{total}} commande attend une confirmation',
    awaitingConfirmation_other: '{{total}} commandes attendent une confirmation',
    seriesTitle: 'Évolution',
    chartLabel: '{{metric}} par période',
    resultTitle: 'Compte de résultat',
    costOfGoods: 'Coût des produits vendus',
    carrierFees: 'Frais transporteurs',
    returnFees: 'Frais de retour',
    damageLoss: 'Pertes sur produits endommagés',
    expenses: 'Charges',
    returnedValue: 'Valeur des retours',
    missingCosts:
      'Lignes vendues sans prix d’achat : {{count}}. La marge reste surestimée tant que le prix d’achat des produits n’est pas renseigné.',
    costHidden:
      'La marge et le résultat net sont réservés aux utilisateurs autorisés à consulter les prix d’achat.',
    topTitle: 'Meilleures ventes',
    product: 'Produit',
    sku: 'Référence',
    units: 'Unités',
    margin: 'Marge',
    noSales: 'Aucune vente livrée sur la période',
    noSalesHelp: 'Les produits apparaissent ici dès qu’une commande est livrée.',
    stockTitle: 'Catalogue et stock',
    overview: {
      stockUnitsAt_one: '{{total}} unité · {{price}} l’unité',
      stockUnitsAt_other: '{{total}} unités · {{price}} l’unité',
      stockPurchaseValue: 'Total achat du stock',
      stockSaleValue: 'Total vente du stock',
      stockUnits_one: '{{total}} unité en stock',
      stockUnits_other: '{{total}} unités en stock',
      from: 'Du',
      to: 'Au',
      products: 'Produits',
      depots: 'Dépôts',
      charges: 'Charges',
      totalGains: 'Total des gains',
      totalReturns: 'Total des retours',
      defectiveProducts: 'Produits défectueux',
      netProfit: 'Bénéfice net',
      totalSales: 'Commandes reçues',
      deliveredSales: 'Ventes livrées',
      netSalesGain: 'Gain net des ventes',
      pendingSales: 'Ventes en attente',
      salesCount_one: '{{total}} reçue',
      salesCount_other: '{{total}} reçues',
      canceledOrders_one: '{{total}} commande annulée',
      canceledOrders_other: '{{total}} commandes annulées',
      deliveredCount_one: '{{total}} livrée',
      deliveredCount_other: '{{total}} livrées',
      pendingCount_one: '{{total}} en attente',
      pendingCount_other: '{{total}} en attente',
      deliveredOrders_one: '{{total}} commande livrée',
      deliveredOrders_other: '{{total}} commandes livrées',
      returnedOrders_one: '{{total}} commande retournée',
      returnedOrders_other: '{{total}} commandes retournées',
      damagedUnits_one: '{{total}} unité abîmée',
      damagedUnits_other: '{{total}} unités abîmées',
      soldUnits_one: '{{total}} unité vendue',
      soldUnits_other: '{{total}} unités vendues',
      topProductsTitle: 'Meilleurs produits',
      customize: 'Personnaliser',
      groupLabel: 'Regroupement',
      group: {
        auto: 'Automatique',
        day: 'Par jour',
        week: 'Par semaine',
        month: 'Par mois',
      },
      rankLabel: 'Classement',
      rank: {
        units: 'Par unités',
        sales: 'Par montant',
      },
      rankTitle: {
        units: 'Unités vendues par produit',
        sales: 'Montant vendu par produit',
      },
      sizeLabel: 'Nombre de produits',
      size_one: 'Top {{count}}',
      size_other: 'Top {{count}}',
      unitsSold_one: '{{total}} unité',
      unitsSold_other: '{{total}} unités',
    },
    widgets: {
      deltaLabel: '{{value}} par rapport à la période comparée',
      comparisonSeries: 'Période comparée',
      trendTitle: {
        sales: 'Évolution des gains',
        created: 'Évolution des ventes',
        confirmed: 'Évolution des commandes confirmées',
        delivered: 'Évolution des ventes livrées',
        returned: 'Évolution des retours',
        canceled: 'Évolution des commandes annulées',
      },
      trendMeasure: {
        sales: 'Gains',
        created: 'Ventes',
        confirmed: 'Commandes confirmées',
        delivered: 'Ventes livrées',
        returned: 'Retours',
        canceled: 'Commandes annulées',
      },
      breakdownTitle: {
        orders: 'Commandes par {{dimension}}',
        delivered: 'Livraisons par {{dimension}}',
        returned: 'Retours par {{dimension}}',
        sales: 'Gains par {{dimension}}',
        deliveryRate: 'Taux de livraison par {{dimension}}',
      },
      breakdownMeasure: {
        orders: 'Commandes',
        delivered: 'Livrées',
        returned: 'Retournées',
        sales: 'Gains',
        deliveryRate: 'Taux de livraison',
      },
      dimension: {
        carrier: 'transporteur',
        governorate: 'gouvernorat',
        source: 'source',
        status: 'statut',
      },
      noCarrier: 'Pas encore de transporteur',
      noGovernorate: 'Sans gouvernorat',
      other: 'Autres',
      versus: '{{value}} (contre {{previous}})',
      kind: {
        funnel: 'Entonnoir des commandes',
      },
      funnelStep: {
        received: 'Reçues',
        confirmed: 'Confirmées',
        shipped: 'Remises au transporteur',
        delivered: 'Livrées',
      },
      funnelFirst: 'Toutes les commandes créées sur la période',
      funnelShare: '{{ofFirst}} des commandes · {{fromPrevious}} de l’étape précédente',
      funnelReturned_one: '{{total}} commande est revenue',
      funnelReturned_other: '{{total}} commandes sont revenues',
      funnelCanceled_one: '{{total}} commande annulée, retirée des étapes suivantes',
      funnelCanceled_other: '{{total}} commandes annulées, retirées des étapes suivantes',
      field: {
        tile: 'Indicateur',
        measure: 'Mesure',
        chart: 'Graphique',
        dimension: 'Répartir par',
        title: 'Titre',
        titleHelp: 'Laissez vide pour garder le titre proposé.',
        size: 'Largeur',
      },
      chart: {
        line: 'Courbes',
        area: 'Aire',
        columns: 'Colonnes',
        stacked: 'Barres empilées',
        grouped: 'Barres côte à côte',
        barList: 'Barres classées',
        donut: 'Anneau',
      },
      size: {
        sm: 'Petit (un quart)',
        md: 'Moyen (un tiers)',
        lg: 'Grand (deux tiers)',
        full: 'Pleine largeur',
      },
      settingsTitle: 'Réglages du widget',
      apply: 'Appliquer',
      preview: 'Aperçu',
      galleryTitle: 'Ajouter un widget',
      gallerySubtitle: 'Choisissez un indicateur ou un graphique ; vous pourrez le modifier ensuite.',
      galleryFull: 'Cette vue compte déjà 24 widgets. Retirez-en un pour en ajouter un autre.',
      group: {
        indicators: 'Indicateurs clés',
        trends: 'Évolutions',
        breakdowns: 'Répartitions',
        orders: 'Commandes et produits',
      },
      preset: {
        kpi: {
          description: 'Un indicateur avec sa tendance et l’écart avec la période comparée.',
        },
        salesTrend: {
          title: 'Évolution des gains',
          description: 'Les ventes livrées en aire, avec la période comparée en pointillés.',
        },
        ordersTrend: {
          title: 'Évolution des commandes',
          description: 'Les commandes créées, en courbe.',
        },
        returnsTrend: {
          title: 'Retours par semaine',
          description: 'Les commandes retournées, semaine par semaine.',
        },
        deliveryRateByCarrier: {
          title: 'Taux de livraison par transporteur',
          description: 'Une courbe par transporteur, semaine par semaine.',
        },
        ordersByCarrier: {
          title: 'Commandes par transporteur',
          description: 'Des barres côte à côte par transporteur.',
        },
        statusesByDay: {
          title: 'Statuts des commandes par jour',
          description: 'Où en sont les commandes de chaque jour, empilées.',
        },
        salesBySource: {
          title: 'Gains par source',
          description: 'Facebook, Instagram, téléphone… en anneau.',
        },
        ordersByGovernorate: {
          title: 'Commandes par gouvernorat',
          description: 'Les gouvernorats qui commandent le plus.',
        },
        funnel: {
          title: 'Entonnoir des commandes',
          description: 'De la réception à la livraison, avec la perte à chaque étape.',
        },
        topProducts: {
          title: 'Meilleurs produits',
          description: 'Les produits les plus vendus, en barres classées.',
        },
      },
      compareLabel: 'Comparer à',
      compare: {
        none: 'Sans comparaison',
        previous: 'Période précédente',
        last_year: 'Même période l’an dernier',
      },
      drag: 'Faites glisser {{title}} pour le déplacer',
      moveEarlier: 'Avancer {{title}}',
      moveLater: 'Reculer {{title}}',
      configure: 'Réglages de {{title}}',
      remove: 'Retirer {{title}}',
      editing: 'Personnalisation du tableau de bord',
      editHint:
        'Faites glisser les widgets ou utilisez les flèches pour les réordonner, ouvrez leurs réglages, puis enregistrez.',
      add: 'Ajouter un widget',
    },
    views: {
      options: 'Options de la vue',
      leaveTitle: 'Quitter sans enregistrer ?',
      leaveMessage: 'Vos modifications du tableau de bord ne sont pas encore enregistrées.',
      leave: 'Quitter',
      stay: 'Rester et enregistrer',
      label: 'Vue du tableau de bord',
      standard: 'Vue standard',
      defaultName: '{{name}} (par défaut)',
      makeDefault: 'Ouvrir cette vue par défaut',
      rename: 'Renommer la vue',
      delete: 'Supprimer la vue',
      saveAs: 'Enregistrer comme nouvelle vue',
      saveAsTitle: 'Enregistrer comme nouvelle vue',
      renameTitle: 'Renommer la vue',
      nameLabel: 'Nom',
      nameRequired: 'Donnez un nom à la vue.',
      deleteTitle: 'Supprimer cette vue ?',
      deleteMessage: 'La vue « {{name}} » sera supprimée. La vue standard reste disponible.',
      created: 'Vue enregistrée',
      updated: 'Vue mise à jour',
      deleted: 'Vue supprimée',
      madeDefault: 'Cette vue s’ouvre désormais par défaut',
      failed: 'La vue n’a pas pu être enregistrée. Réessayez.',
    },
  },
  period: {
    legend: 'Période',
    today: 'Aujourd’hui',
    last_7_days: '7 derniers jours',
    this_month: 'Ce mois-ci',
    last_month: 'Mois dernier',
    this_year: 'Cette année',
  },
  placeholder: {
    comingSoon: 'Cet écran sera disponible prochainement.',
  },
  common: {
    rowAction: '{{action}} : {{name}}',
    copyBarcode: 'Copier le code-barres {{code}}',
    barcodeCopied: 'Code-barres copié',
    copyFailed: 'Copie impossible : sélectionnez le code-barres et copiez-le à la main.',
    clearFilters: 'Effacer les filtres',
    refineSearch: '{{shown}} résultats affichés sur {{total}} : précisez la recherche.',
    shown: '{{shown}} sur {{total}}',
    loadMore: 'Afficher plus',
    loadingMore: 'Chargement…',
    retry: 'Réessayer',
    cancel: 'Annuler',
    save: 'Enregistrer',
    saving: 'Enregistrement…',
    close: 'Fermer',
    all: 'Toutes',
  },
  catalog: {
    categoriesContext: 'Organisez vos produits en rayons et sous-rayons.',
    productsContext: 'Votre catalogue et ses variantes : prix, stock par dépôt et statut.',
    name: 'Nom',
    slug: 'Adresse web',
    status: 'Statut',
    status_all: 'Tous',
    status_active: 'Actif',
    status_archived: 'Archivé',
    status_draft: 'Inactif',
    position: 'Position',
    positionHelp: 'Ordre d’affichage, du plus petit au plus grand.',
    parent: 'Catégorie parente',
    noParent: 'Aucune (rayon principal)',
    actions: 'Actions',
    delete: 'Supprimer',
    newCategory: 'Nouvelle catégorie',
    editCategory: 'Modifier la catégorie',
    categorySaved: 'Catégorie enregistrée',
    categoryArchived: 'Catégorie archivée',
    noCategories: 'Aucune catégorie',
    noCategoriesHelp: 'Créez une première catégorie pour ranger vos produits.',
    nameRequired: 'Le nom est obligatoire',
    loadFailed: 'Chargement impossible',
    reference: 'Référence',
    variants: 'Variantes',
    price: 'Prix',
    search: 'Rechercher',
    searchPlaceholder: 'Nom, référence ou SKU',
    searchSubmit: 'Lancer la recherche',
    category: 'Catégorie',
    newProduct: 'Nouveau produit',
    productSaved: 'Produit enregistré',
    productArchived: 'Produit archivé',
    noProducts: 'Aucun produit',
    noProductsHelp: 'Créez un premier produit pour commencer à vendre.',
    sku: 'SKU',
  },
  origin: {
    local: 'Local',
    imported: 'Importé · {{country}}',
  },
  productEditor: {
    essentialsHint: 'Le nom, la description et le classement que voient vos clients.',
    mediaHint: 'Des photos nettes vendent mieux ; la première sert de couverture.',
    pricingHint: 'Coût d’achat, prix de vente et promotion.',
    variantsHint: 'Tailles, couleurs et le code de chaque déclinaison.',
    stockHint: 'Quantités par dépôt et seuil d’alerte.',
    shippingHint: 'Poids et dimensions transmis au transporteur.',
    moreHint: 'Garantie et informations complémentaires.',
    media: 'Médias',
    mediaDrop: 'Déposez vos photos ici ou cliquez pour les choisir',
    mediaHelp: 'JPEG, PNG, WebP ou AVIF, 10 Mo au plus. Vous pouvez aussi coller une image.',
    mediaEmpty: 'Aucune image. La première image ajoutée devient la couverture.',
    mediaGallery: 'Images du produit',
    mediaImage: 'Image {{position}}',
    mediaCover: 'Couverture',
    mediaAlt: 'Description de l’image',
    mediaEarlier: 'Avancer l’image {{position}}',
    mediaLater: 'Reculer l’image {{position}}',
    mediaRemove: 'Retirer l’image {{position}}',
    mediaDismiss: 'Ignorer',
    mediaAdd: 'Ajouter',
    mediaRefused: '{{name}} n’est pas une image acceptée (JPEG, PNG, WebP, AVIF).',
    mediaPhase_hashing: 'Préparation…',
    mediaPhase_uploading: 'Envoi…',
    mediaPhase_processing: 'Vérification et optimisation…',
    newTitle: 'Nouveau produit',
    context: 'Toutes les informations du produit sur une seule page',
    createdBy: 'Créé par {{name}}',
    sections: 'Sections du produit',
    essentials: 'Essentiel',
    pricing: 'Prix',
    variants: 'Variantes',
    stock: 'Stock',
    shipping: 'Expédition',
    more: 'Plus d’options',
    languages: 'Langues',
    translationMissing: 'à traduire',
    description: 'Description',
    origin: 'Provenance',
    originHelp: 'Local ou importé, avec le pays',
    originCountry: 'Importé de',
    originAddCountry: 'Ajouter un pays d’import',
    originFindCountry: 'Chercher un pays',
    originNoCountry: 'Aucun pays ne correspond',
    originSeveral:
      'Chaque provenance devient une variante avec son propre stock. Les prix restent les mêmes, sauf si vous activez « Prix différents selon la variante ».',
    originRemove: 'Retirer {{origin}}',
    referenceHelp:
      'Proposée à partir de la filiale et de la catégorie, et modifiable. Unique dans votre boutique.',
    noCategory: 'Aucune catégorie',
    subCategory: 'Sous-catégorie',
    noSubCategory: 'Aucune sous-catégorie',
    sellingPrice: 'Prix de vente',
    cost: 'Prix d’achat',
    costHelp: 'Visible uniquement par les rôles autorisés',
    margin: 'Marge',
    promo: 'Mettre en promotion',
    regularPrice: 'Prix barré',
    regularPriceHelp: 'Le prix avant promotion, affiché barré à côté du prix de vente',
    perVariantPrice: 'Prix différents selon la variante',
    perVariantPriceHelp:
      'Prix d’achat et de vente saisis sur chaque variante (ex. provenance locale ou importée)',
    barcode: 'Code-barres',
    stockHelp: 'Le stock change uniquement par des mouvements, pour garder la traçabilité.',
    weight: 'Poids',
    unitKg: 'kg',
    unitCm: 'cm',
    lengthCm: 'Longueur',
    widthCm: 'Largeur',
    heightCm: 'Hauteur',
    weightHelp: 'Appliqué à toutes les variantes',
    warranty: 'Garantie (mois)',
    saveDraft: 'Enregistrer le brouillon',
    publish: 'Activer',
    deactivate: 'Désactiver',
    archivedNotice: 'Produit archivé : il n’apparaît plus dans les listes ni dans les commandes.',
    restore: 'Restaurer le produit',
    undo: 'Annuler',
    errorsTitle: 'Corrigez ces points avant d’enregistrer',
    fixField: 'Aller au champ',
    unsavedChanges: 'Des modifications ne sont pas enregistrées. Si vous quittez, elles seront perdues.',
    leaveTitle: 'Quitter l’éditeur ?',
    leave: 'Quitter sans enregistrer',
    stay: 'Rester',
    notFound: 'Ce produit est introuvable.',
    backToProducts: 'Retour aux produits',
    outcome_created: 'Produit créé',
    outcome_saved: 'Produit enregistré',
    outcome_published: 'Produit activé',
    outcome_deactivated: 'Produit désactivé',
    hasOptions: 'Ce produit a des options (couleur, taille…)',
    hasOptionsHelp: 'Chaque combinaison de valeurs devient une variante avec son SKU et son stock.',
    optionsHelp: 'Cochez les valeurs disponibles pour ce produit. Chaque combinaison devient une variante.',
    newOptionName: 'Nouvelle option (ex. Matière)',
    createOption: 'Créer l’option',
    newValueFor: 'Nouvelle valeur pour {{option}}',
    addValue: 'Ajouter la valeur',
    valuesChosen_one: '{{count}} sélectionnée',
    valuesChosen_other: '{{count}} sélectionnées',
    optionLimit: '3 options au maximum par produit',
    variantsOnSale: 'Variantes en vente : {{count}}',
    singleVariant: 'Variante unique',
    stockTotal: 'Quantité totale',
    stockAddVariant: 'Ajouter une variante',
    stockSplitVariant: 'Variante',
    stockSplitQuantity: 'Quantité',
    stockSplitRemove: 'Retirer la ligne de variante {{position}}',
    stockSplitHelp_one: 'Attribuée à {{count}} variante',
    stockSplitHelp_other: 'Répartie à parts égales entre les {{count}} variantes',
    stockAddDepot: 'Ajouter un dépôt :',
    stockDepots: 'Dépôts de ce produit',
    stockDefault: 'par défaut',
    stockDropDepot: 'Retirer {{depot}}',
    stockGrandTotal_one: 'Total : {{total}} unité dans {{depots}} dépôts',
    stockGrandTotal_other: 'Total : {{total}} unités dans {{depots}} dépôts',
    stockThreshold: 'Seuil de notification',
    stockThresholdHelp: 'Vous recevez une alerte lorsque le stock disponible atteint ce niveau.',
    stockThresholdPlaceholder: 'ex. 5',
    skuHelp: 'Laissez vide pour utiliser le SKU proposé.',
    initialStockHelp:
      'Saisissez le stock de départ des variantes qui n’ont encore aucun mouvement. Il sera enregistré avec le produit.',
    initialStockFailed: 'Produit enregistré, mais le stock initial ne l’a pas été :',
    autosave_saving: 'Enregistrement…',
    autosave_saved: 'Brouillon enregistré',
    autosave_failed: 'Échec de l’enregistrement automatique',
    errors: {
      FINANCE_REMITTED_BEFORE_DELIVERY:
        'Le transporteur a signalé le paiement avant la livraison ; il sera pris en compte dès que la livraison sera confirmée.',
      nameRequired: 'Le nom est obligatoire dans la langue par défaut de la boutique.',
      priceInvalid: 'Saisissez un montant positif avec au plus 3 décimales.',
      regularPriceTooLow: 'Le prix barré doit être supérieur au prix de vente.',
      priceBelowCost: 'Le prix de vente doit être supérieur ou égal au prix d’achat.',
      variantRequired: 'Ajoutez au moins une variante.',
      referenceRequired: 'La référence est obligatoire.',
      weightInvalid: 'Saisissez un poids en kg avec au plus 3 décimales.',
      warrantyInvalid: 'Saisissez un nombre entier de mois, entre 1 et 600.',
      optionValuesRequired: 'Choisissez une option et au moins une valeur.',
      quantityInvalid: 'Saisissez un nombre entier de 0 à 100 000.',
      stockRequired: 'Saisissez au moins une unité en stock dans un dépôt.',
      dimensionInvalid: 'Saisissez une dimension en centimètres, par ex. 12,5.',
      splitMismatch: 'La somme des quantités des variantes doit être égale à la quantité totale du dépôt.',
    },
  },
  categoryList: {
    detailPlacement: 'Emplacement',
    detailPlacementHint: 'Où cette catégorie se range dans la boutique.',
    detailTranslationsHint: 'Le nom et l’adresse affichés dans chaque langue.',
    status_active: 'Active',
    status_archived: 'Archivée',
    productsUnit_one: 'produit',
    productsUnit_other: 'produits',
    summaryRoots_one: '{{total}} rayon',
    summaryRoots_other: '{{total}} rayons',
    summaryChildren_one: '{{total}} sous-catégorie',
    summaryChildren_other: '{{total}} sous-catégories',
    summaryProducts_one: '{{total}} produit',
    summaryProducts_other: '{{total}} produits',
    summaryArchived_one: '{{total}} catégorie archivée',
    summaryArchived_other: '{{total}} catégories archivées',
    nameIn: 'Nom en {{language}}',
    nameRequiredIn: 'Obligatoire : la boutique l’affiche par défaut.',
    nameFallback: 'Facultatif. Sans traduction, la boutique affiche le nom en {{language}}.',
    address: 'Adresse web',
    addressPending: 'Créée à l’enregistrement',
    addressHelp: 'Générée à partir du nom en {{language}}.',
    search: 'Rechercher une catégorie',
    view_active: 'Actives',
    view_archived: 'Archivées',
    foldAll: 'Tout replier',
    unfoldAll: 'Tout déplier',
    toggle: 'Afficher ou masquer les sous-catégories de {{name}}',
    languages: 'Langues',
    translated: 'Traduite en {{language}}',
    untranslated: 'Pas encore traduite en {{language}}',
    products: 'Produits',
    productCount_one: '{{total}} produit',
    productCount_other: '{{total}} produits',
    edit: 'Modifier {{name}}',
    archive: 'Archiver {{name}}',
    noMatch: 'Aucune catégorie ne correspond',
    noMatchHelp: 'Essayez un autre nom, dans n’importe quelle langue.',
    coverageTitle: 'Traductions',
    coverageHelp:
      'Le nom dans la langue par défaut est obligatoire. Sans traduction, la boutique affiche ce nom.',
    coverageCount: '{{translated}}/{{total}}',
    archiveTip: 'Une catégorie archivée disparaît de la boutique ; ses produits restent dans le catalogue.',
    detailParent: 'Catégorie parente',
    detailRoot: 'Catégorie principale',
    detailPosition: 'Position',
    detailTranslations: 'Nom dans chaque langue',
    detailMissing: 'Pas encore traduit',
    detailNoDescription: 'Aucune description',
  },
  productList: {
    details: 'Voir',
    active: 'Actif',
    adjustRow: 'Opération de stock sur {{name}}',
    edit: 'Modifier',
    kpi_unitsInDepots_one: '{{units}} unité dans {{depots}}',
    kpi_unitsInDepots_other: '{{units}} unités dans {{depots}}',
    kpi_depots_one: '{{total}} dépôt',
    kpi_depots_other: '{{total}} dépôts',
    printLabels: 'Imprimer les étiquettes',
    reference: 'Référence',
    kpi_saleValue: 'Valeur du stock au prix de vente',
    kpi_costValue: 'Au prix d’achat',
    kpi_ofCatalogue: 'sur {{total}} au catalogue',
    kpi_active: 'Produits actifs',
    kpi_low: 'Stock bas',
    kpi_out: 'En rupture',
    kpi_show: 'Voir les produits',
    product: 'Produit',
    variantCount_one: '{{count}} variante',
    variantCount_other: '{{count}} variantes',
    allCategories: 'Toutes les catégories',
    optionValue: 'Option',
    allOptionValues: 'Toutes les options',
    findOptionValue: 'Chercher une option (ex. Provenance)',
    noOptionValueMatch: 'Aucune option ne correspond',
    findCategory: 'Chercher une catégorie',
    noCategoryMatch: 'Aucune catégorie ne correspond',
    view: 'Afficher',
    view_all: 'Tous',
    view_active: 'Actifs',
    view_draft: 'Inactifs',
    view_archived: 'Archivés',
    view_low: 'Stock bas',
    view_out: 'Rupture',
    view_sale: 'Ventes',
    view_return: 'Retours au dépôt',
    view_defective: 'Défectueux',
    view_loss: 'Pertes',
    operationPeriod: 'Période des opérations',
    period_last_7_days: '7 derniers jours',
    period_last_30_days: '30 derniers jours',
    period_this_month: 'Ce mois-ci',
    period_last_month: 'Mois dernier',
    period_this_year: 'Cette année',
    period_custom: 'Dates personnalisées',
    periodFrom: 'Du',
    periodTo: 'Au',
    sort: 'Trier par',
    sort_created_desc: 'Plus récents',
    sort_created_asc: 'Plus anciens',
    sort_updated_desc: 'Modifiés récemment',
    sort_name_asc: 'Nom (A → Z)',
    searchShortcut: 'Raccourci : /',
    stock: 'Stock',
    stockUnavailable: 'Le stock n’a pas pu être chargé.',
    selectProduct: 'Sélectionner {{name}}',
    selectAll: 'Sélectionner les produits affichés',
    shown: '{{shown}} sur {{total}}',
    bulkActions: 'Actions sur la sélection',
    selected: 'Produits sélectionnés : {{count}}',
    clearSelection: 'Désélectionner',
  },
  productStatus: {
    published: 'Produits activés : {{count}}',
    deactivated: 'Produits désactivés : {{count}}',
    archived: 'Produits supprimés : {{count}}',
    restored: 'Produits rétablis : {{count}}',
    failed: '{{name}} : {{reason}}',
  },
  stockValue: {
    title: 'Stock en dépôt',
    hint: 'Au prix de vente aujourd’hui, avec sa valeur au prix d’achat',
    units: 'Unités',
    cost: 'Total achat',
  },
  productStatistics: {
    sectionTitle: 'Statistiques et mouvements',
    netGain: 'Gain net',
    ordered: 'Commandées',
    delivered: 'Livrées',
    manualSales: 'Ventes manuelles',
    carrierReturned: 'Retours transporteur',
    receivedBack: 'Reçus au dépôt',
    missing: 'Manquants',
    missingHint: 'Retournés par le transporteur mais jamais arrivés au dépôt',
    defective: 'Défectueux',
    lost: 'Pertes',
    amount: 'Montant',
    revenue: 'Chiffre d’affaires',
    cost: 'Total achat',
    margin: 'Marge',
    value: 'Valeur au prix d’achat',
    chartTitle: 'Évolution',
    metric_revenue: 'Chiffre d’affaires',
    metric_losses: 'Pertes',
    chartLabel: '{{metric}} par période',
    historyTitle: 'Historique des mouvements',
  },
  quickStock: {
    title: 'Ajouter du stock',
    onHand: 'En stock',
    quickAmounts: 'Ajout rapide',
    addAmount: 'Ajouter {{count}} à {{name}}',
    decrement: 'Retirer une unité de {{name}}',
    increment: 'Ajouter une unité à {{name}}',
    total_one: '{{change}} unité',
    total_other: '{{change}} unités',
    confirm: 'Ajouter',
    added: 'Stock ajouté : {{change}}',
  },
  adjustStock: {
    operationHint: 'Le type de mouvement à enregistrer.',
    depotHint: 'Le dépôt dont le stock change.',
    linesHint: 'Saisissez la quantité pour chaque variante concernée.',
    noteHint: 'Visible dans le journal des mouvements.',
    title: 'Opération de stock',
    reason: 'Opération',
    reason_sale: 'Vente',
    reason_return: 'Retour au dépôt',
    reason_defective: 'Défectueux',
    reason_loss: 'Perte',
    reason_receipt: 'Réception',
    reason_correction: 'Correction d’inventaire',
    reasonHelp_sale:
      'Vente hors commande (boutique physique, live…) : sort les unités du stock, valorisées au prix de vente.',
    reasonHelp_return: 'Remet en stock les unités retournées effectivement reçues au dépôt.',
    reasonHelp_defective: 'Sort du stock les unités endommagées, valorisées au prix d’achat.',
    reasonHelp_loss: 'Sort du stock les unités perdues ou volées, valorisées au prix d’achat.',
    unitPrice: 'Prix de vente unitaire',
    unitPriceInvalid: 'Saisissez le prix de vente, par ex. 45,000.',
    quantity: 'Quantité',
    lines: 'Variantes à ajuster',
    products_one: '{{count}} produit',
    products_other: '{{count}} produits',
    notePlaceholder: 'Ex. vente au salon du 12 octobre, colis abîmé au dépôt',
    after: 'Après',
    invalid: 'Nombre entier attendu',
    negative: 'Stock négatif ({{after}})',
    summary: 'Variantes : {{count}} · {{change}}',
    confirm: 'Enregistrer l’opération',
    recorded: 'Mouvements enregistrés : {{count}}',
  },
  shortcuts: {
    title: 'Raccourcis clavier',
    next: 'Produit suivant',
    previous: 'Produit précédent',
    open: 'Aperçu du produit',
    edit: 'Modifier le produit',
    adjust: 'Opération de stock',
    select: 'Sélectionner le produit',
    search: 'Rechercher',
    help: 'Afficher cette aide',
    close: 'Fermer ou désélectionner',
  },
  productImport: {
    openCsv: 'Importer (CSV)',
    open: 'Importer',
    title: 'Importer des produits',
    drop: 'Déposez votre fichier CSV ici ou cliquez pour le choisir',
    dropHelp:
      'Une ligne par variante ; les lignes de même référence forment un produit. UTF-8, séparateur ; ou ,',
    template: 'Télécharger le modèle',
    notCsv: '{{name}} n’est pas un fichier CSV.',
    unreadable: 'Ce fichier CSV est illisible : enregistrez-le à nouveau en CSV UTF-8 depuis votre tableur.',
    mappingHelp: 'Indiquez ce que contient chaque colonne. Les colonnes ignorées ne sont pas importées.',
    columns: 'Colonnes du fichier',
    unnamedColumn: 'Colonne {{position}}',
    importAs: 'Importer « {{column}} » comme',
    field_ignore: 'Ne pas importer',
    field_reference: 'Référence',
    field_category: 'Catégorie',
    field_sku: 'SKU',
    field_barcode: 'Code-barres',
    field_price: 'Prix de vente',
    field_regularPrice: 'Prix barré',
    field_cost: 'Prix d’achat',
    field_weightKg: 'Poids (kg)',
    field_stock: 'Stock initial',
    field_option: 'Option (nom de la colonne)',
    field_name_in: 'Nom ({{locale}})',
    field_description_in: 'Description ({{locale}})',
    depot: 'Dépôt du stock initial',
    chooseDepot: 'Choisir un dépôt',
    problem_reference: 'Associez une colonne à la référence.',
    problem_price: 'Associez une colonne au prix de vente.',
    problem_name: 'Associez une colonne au nom en {{locale}}, la langue de la boutique.',
    problem_duplicate: 'Deux colonnes sont associées au même champ.',
    problem_options: 'Trois colonnes d’options au maximum.',
    otherFile: 'Choisir un autre fichier',
    check: 'Vérifier le fichier',
    working_checking: 'Envoi et vérification du fichier…',
    working_applying: 'Création des produits…',
    ready: 'Produits prêts : {{count}}',
    toFix: 'Lignes à corriger : {{count}}',
    rowsRead: 'Lignes lues : {{count}}',
    moreErrors: 'Et {{count}} autres erreurs non affichées.',
    row: 'Ligne',
    column: 'Colonne',
    problem: 'Problème',
    value: 'Valeur',
    error_required: 'Valeur obligatoire manquante',
    error_invalid_decimal: 'Nombre invalide (ex. 79,500)',
    error_invalid_integer: 'Nombre entier attendu',
    error_formula: 'Formule de tableur refusée',
    error_too_long: 'Texte trop long',
    error_inconsistent_product: 'Les lignes de cette référence ne concordent pas',
    error_mixed_options: 'Les variantes n’ont pas les mêmes options',
    error_duplicate_variant: 'Variante en double',
    error_duplicate_sku: 'SKU utilisé deux fois dans le fichier',
    error_reference_taken: 'Référence déjà utilisée dans le catalogue',
    error_sku_taken: 'SKU déjà utilisé dans le catalogue',
    error_unknown_category: 'Catégorie inconnue',
    error_header_mismatch: 'L’en-tête du fichier a changé',
    error_too_many_rows: 'Fichier trop volumineux (trop de lignes)',
    apply: 'Importer les produits prêts ({{count}})',
    issues: 'Lignes à corriger',
    issueWhere: 'Ligne {{row}} · colonne {{column}}',
    created: 'Produits créés : {{count}}',
    failed: 'L’import n’a pas pu aboutir',
    draftsHelp: 'Les produits importés sont inactifs : vérifiez-les puis activez-les.',
    failures: 'Produits non créés',
    failure: '{{reference}} ({{stage}}) : {{reason}}',
    stage_product: 'création',
    stage_stock: 'stock initial',
  },
  quickView: {
    edit: 'Modifier',
    noCategory: 'Sans catégorie',
    noImage: 'Aucune image',
  },
  stockMatrix: {
    threshold: 'Seuil',
    caption: 'Stock par variante et par dépôt',
    total: 'Total',
    low: 'Stock bas',
    out: 'Rupture',
    shownTotal: 'Total affiché',
    legend_ok: 'Disponible',
    legend_low: 'Stock bas (seuil ou moins)',
    legend_out: 'Rupture',
  },
  inventory: {
    depotColumns: 'Dépôts',
    depotColumnsAll: 'Tous ({{count}})',
    depotColumnsSome: '{{shown}} sur {{total}}',
    depotColumnsStocked: 'Avec du stock',
    levelsTab: 'Niveaux de stock',
    allMovements: 'Tous',
    variantAndDepot: 'Variante · dépôt',
    movementsShown_one: '{{shown}} sur {{total}} mouvement',
    movementsShown_other: '{{shown}} sur {{total}} mouvements',
    unitsAvailable: 'Unités disponibles',
    levelsSearchLabel: 'Chercher dans le stock',
    levelsSearch: 'Produit, référence ou SKU',
    allDepots: 'Tous les dépôts',
    restockOnly: 'Stock bas uniquement',
    levelsShown_one: '{{shown}} variante affichée sur {{total}}',
    levelsShown_other: '{{shown}} variantes affichées sur {{total}}',
    depotLow: 'Variantes en stock bas',
    kpi_available: 'Unités disponibles',
    kpi_variants: 'Variantes suivies',
    kpi_inProducts_one: 'dans {{total}} produit',
    kpi_inProducts_other: 'dans {{total}} produits',
    kpi_low: 'Stock bas',
    kpi_lowHint: 'sous le seuil d’alerte',
    kpi_out: 'En rupture',
    kpi_outHint: 'plus aucune unité disponible',
    searchVariant: 'Rechercher un produit',
    search: 'Rechercher',
    searchFirst: 'Recherchez un produit par nom, référence ou SKU',
    context: 'Dépôts, niveaux par variante et journal des mouvements.',
    movementsTab: 'Mouvements',
    depotsTab: 'Dépôts',
    variant: 'Variante',
    variantRequired: 'Choisissez une variante',
    noVariants: 'Aucune variante disponible',
    depot: 'Dépôt',
    depotRequired: 'Choisissez un dépôt',
    depotName: 'Nom',
    depotCode: 'Code',
    defaultDepot: 'Par défaut',
    yes: 'Oui',
    onHand: 'En stock',
    available: 'Disponible',
    threshold: 'Seuil',
    occurredAt: 'Date',
    kind: 'Type',
    kind_restock: 'Réapprovisionnement',
    kind_restock_pending: 'Réapprovisionnement en attente',
    kind_commit: 'Sortie',
    kind_write_off: 'Perte',
    kind_adjustment: 'Ajustement',
    kind_import: 'Import',
    quantity: 'Quantité',
    quantityHelp: 'Le sens est déterminé par le type de mouvement.',
    quantityRequired: 'La quantité doit être un entier positif',
    note: 'Note',
    state: 'État',
    state_applied: 'Appliqué',
    state_pending: 'En attente',
    state_voided: 'Annulé',
    newMovement: 'Nouveau mouvement',
    movementRecorded: 'Mouvement enregistré',
    loadFailed: 'Chargement impossible',
    noMovements: 'Aucun mouvement',
    noMovementsHelp: 'Enregistrez un premier mouvement pour alimenter le journal.',
    noDepots: 'Aucun dépôt',
    noDepotsHelp: 'Créez un dépôt pour commencer à suivre votre stock.',
  },
  customers: {
    identitySection: 'Identité',
    identityHint: 'Comment joindre ce client.',
    addressSection: 'Adresse de livraison',
    addressHint: 'Préremplie dans chaque nouvelle commande.',
    notesSection: 'Notes',
    context: 'Le carnet de vos clients : téléphone, adresse et notes de livraison.',
    newCustomer: 'Nouveau client',
    editCustomer: 'Modifier le client',
    customer: 'Fiche client',
    edit: 'Modifier',
    name: 'Nom complet',
    phone: 'Téléphone',
    phoneHelp: 'Numéro local ou international, par ex. 98 123 456',
    secondPhone: 'Second téléphone',
    email: 'E-mail',
    address: 'Adresse',
    governorate: 'Gouvernorat',
    city: 'Ville',
    postalCode: 'Code postal',
    notes: 'Notes',
    notesHelp: 'Consignes utiles au livreur ou à l’équipe.',
    createdAt: 'Créé le',
    searchPhone: 'Rechercher par téléphone',
    search: 'Rechercher',
    clearSearch: 'Effacer',
    noCustomers: 'Aucun client pour l’instant',
    noCustomersHelp:
      'Ajoutez votre premier client ; chaque nouvelle commande en crée aussi un automatiquement.',
    noMatch: 'Aucun client trouvé',
    noMatchHelp: 'Vérifiez le numéro ou les filtres.',
    saved: 'Client enregistré',
    savedWithOrders_one:
      'Client enregistré, et {{count}} commande pas encore remise au transporteur mise à jour',
    savedWithOrders_other:
      'Client enregistré, et {{count}} commandes pas encore remises au transporteur mises à jour',
    masked: 'Les données personnelles sont masquées pour votre rôle.',
    phoneTaken: 'Un client utilise déjà ce numéro.',
    openExisting: 'Ouvrir la fiche',
    nameRequired: 'Le nom est obligatoire.',
    phoneRequired: 'Le téléphone est obligatoire.',
    phoneInvalid: 'Ce numéro n’est pas valide pour le pays de la boutique, ex. 98 123 456.',
    emailInvalid: 'Cette adresse e-mail n’est pas valide.',
    fieldInvalid: 'Cette valeur n’est pas acceptée.',
    shown: 'Clients affichés : {{shown}} sur {{total}}',
  },
  depots: {
    identitySection: 'Dépôt',
    identityHint: 'Comment ce dépôt apparaît dans l’application.',
    placeSection: 'Contact et adresse',
    placeHint: 'Où se trouve le dépôt et comment le joindre.',
    settingsSection: 'Réglages',
    defaultSwitch: 'Dépôt par défaut',
    add: 'Nouveau dépôt',
    newTitle: 'Nouveau dépôt',
    count_one: '{{count}} dépôt',
    count_other: '{{count}} dépôts',
    figures: 'Indicateurs du dépôt {{name}}',
    saleValue: 'Valeur au prix de vente',
    showMovements: 'Voir les mouvements de ce dépôt',
    nameRequired: 'Le nom est obligatoire',
    codeRequired: 'Le code est obligatoire',
    codeHelp: 'Court et unique, par exemple TUN ou SFX.',
    phone: 'Téléphone',
    address: 'Adresse',
    city: 'Ville',
    tooLong: 'Ce texte est trop long',
    defaultHelp: 'Le dépôt utilisé par défaut pour les commandes et les entrées de stock.',
    defaultKept: 'C’est le dépôt par défaut : choisissez-en un autre pour le remplacer.',
    editRow: 'Modifier {{name}}',
    archiveRow: 'Archiver {{name}}',
    archiveTitle: 'Archiver {{name}} ?',
    archiveMessage:
      'Le dépôt n’apparaîtra plus dans les commandes ni les mouvements. Son historique est conservé. Un dépôt qui contient encore du stock ne peut pas être archivé.',
    archive: 'Archiver',
    archived: 'Dépôt {{name}} archivé',
    created: 'Dépôt {{name}} créé',
    saved: 'Dépôt {{name}} enregistré',
  },
  companies: {
    all: 'Toutes les sociétés',
    label: 'Société',
    main: '{{name}} (société principale)',
    orderHelp: 'La société choisit les produits de la commande et le compte transporteur qui l’expédie.',
  },
  subsidiaries: {
    title: 'Filiales',
    context:
      'Les sociétés de la boutique, utilisées sur les produits, les commandes, les dépenses et les comptes transporteurs.',
    archived: 'Archivée',
    none: 'Aucune filiale',
    noneHelp: 'Les filiales sont créées via l’API.',
    noDetails: 'Aucune coordonnée',
  },
  team: {
    title: 'Équipe',
    context: 'Les personnes qui travaillent dans la boutique et ce qu’elles peuvent faire.',
    invite: 'Inviter un membre',
    you: 'Vous',
    preset_admin: 'Administrateur',
    preset_staff: 'Collaborateur',
    preset_viewer: 'Lecture seule',
    presetHelp_admin: 'Tout gérer, y compris l’équipe et les réglages.',
    presetHelp_staff: 'Commandes, expéditions et stock au quotidien.',
    presetHelp_viewer: 'Consulter sans rien modifier.',
    noPreset: 'Accès personnalisé',
    status_pending: 'Invitation envoyée',
    status_paused: 'En pause',
    outside: 'Géré hors du portail',
    access: 'Niveau d’accès',
    extra: 'Autorisations supplémentaires',
    extraHelp: 'S’ajoutent à celles du niveau choisi.',
    group_orders: 'Commandes',
    group_catalog: 'Catalogue',
    group_stock: 'Stock',
    group_finance: 'Finance',
    group_settings: 'Réglages',
    email: 'E-mail',
    firstName: 'Prénom',
    lastName: 'Nom',
    subsidiary: 'Filiale',
    noSubsidiary: 'Aucune',
    inviteTitle: 'Inviter un membre',
    inviteSubmit: 'Envoyer l’invitation',
    inviteHelp: 'La personne reçoit un e-mail pour choisir son mot de passe. Le lien est valable 3 jours.',
    invited: 'Invitation envoyée à {{email}}',
    invitedNoEmail:
      '{{name}} a accès, mais l’e-mail d’invitation n’a pas pu être envoyé. Renvoyez-le depuis sa fiche.',
    added: '{{name}} a de nouveau accès à la boutique',
    emailInvalid: 'Indiquez une adresse e-mail valide.',
    firstNameRequired: 'Indiquez un prénom.',
    saved: 'Accès de {{name}} enregistré',
    pause: 'Mettre en pause',
    resume: 'Réactiver',
    paused: '{{name}} est en pause',
    resumed: '{{name}} a de nouveau accès',
    pauseTitle: 'Mettre {{name}} en pause ?',
    pauseMessage:
      'La personne est déconnectée immédiatement et ne peut plus se connecter jusqu’à sa réactivation.',
    remove: 'Retirer de la boutique',
    removeTitle: 'Retirer {{name}} ?',
    removeMessage: 'La personne perd tout accès à la boutique. Son nom reste dans l’historique.',
    removed: '{{name}} n’a plus accès à la boutique',
    resend: 'Renvoyer l’invitation',
    resent: 'Invitation renvoyée à {{email}}',
    selfNote: 'Pour changer votre propre accès, demandez à un autre administrateur.',
    perm_orders_write: 'Créer et modifier des commandes',
    perm_orders_confirm: 'Confirmer des commandes',
    perm_orders_dispatch: 'Remettre au transporteur et imprimer les étiquettes',
    perm_orders_pii_read: 'Voir les téléphones et adresses des clients',
    perm_orders_refund: 'Effectuer des remboursements',
    perm_catalog_write: 'Gérer les produits et catégories',
    perm_catalog_cost: 'Voir les prix d’achat',
    perm_inventory_write: 'Enregistrer des mouvements de stock',
    perm_finance_read: 'Consulter les données financières',
    perm_finance_write: 'Gérer les dépenses et les versements',
    perm_carriers_manage: 'Gérer les transporteurs',
    perm_settings_manage: 'Gérer les réglages de la boutique',
    perm_users_manage: 'Gérer l’équipe',
    perm_audit_read: 'Voir l’historique des modifications',
  },
  history: {
    title: 'Historique',
    context: 'Qui a modifié quoi dans la boutique, et quand.',
    sectionContext:
      'Chaque modification effectuée dans la boutique : équipe, filiales, produits, catégories, dépôts, paramètres des commandes et dépenses.',
    openPage: 'Ouvrir l’historique',
    kindLegend: 'Type de modification',
    kind_all: 'Tout',
    kind_people: 'Équipe',
    kind_subsidiaries: 'Filiales',
    kind_products: 'Produits',
    kind_categories: 'Catégories',
    kind_depots: 'Dépôts',
    kind_settings: 'Paramètres',
    kind_finance: 'Dépenses',
    kind_exports: 'Exportations',
    from: 'Du',
    to: 'Au',
    byActor: 'Modifications de {{name}}',
    byChosenActor: 'Modifications de la personne choisie',
    everyone: 'Afficher tous les membres',
    onlyActor: 'Afficher uniquement les modifications de {{name}}',
    open: 'Ouvrir',
    openSubject: 'Ouvrir {{subject}}',
    before: 'avant',
    after: 'après',
    loading: 'Chargement de l’historique',
    shown: '{{count}} modifications affichées sur {{total}}',
    empty: 'Aucune modification pour l’instant',
    emptyHint: 'Les modifications effectuées dans la boutique apparaîtront ici.',
    emptyFiltered: 'Aucune modification pour ces filtres',
    emptyFilteredHint: 'Élargissez la période ou choisissez un autre type.',
    clearFilters: 'Effacer les filtres',
    actor_person: 'Un membre de l’équipe',
    actor_system: 'Système',
    actor_support: 'Support Al-WidadiaShop',
    actor_unknown: 'Utilisateur supprimé',
    subject_unnamed: 'sans nom',
    action_order_export_requested: 'a exporté les commandes',
    action_other: 'a modifié « {{subject}} »',
    action_team_member_invited: 'a invité {{subject}} dans l’équipe',
    action_team_member_access_changed: 'a changé les accès de {{subject}}',
    action_team_member_paused: 'a suspendu l’accès de {{subject}}',
    action_team_member_resumed: 'a rétabli l’accès de {{subject}}',
    action_team_member_removed: 'a retiré {{subject}} de l’équipe',
    action_team_member_renamed: 'a changé son nom en {{subject}}',
    action_user_account_sessions_ended: 'a déconnecté ses autres appareils',
    field_endedSessions: 'Sessions fermées',
    action_subsidiary_created: 'a ajouté la filiale « {{subject}} »',
    action_subsidiary_revised: 'a modifié la filiale « {{subject}} »',
    action_subsidiary_archived: 'a archivé la filiale « {{subject}} »',
    action_subsidiary_restored: 'a rétabli la filiale « {{subject}} »',
    action_product_created: 'a créé le produit « {{subject}} »',
    action_product_revised: 'a modifié le produit « {{subject}} »',
    action_product_active: 'a activé le produit « {{subject}} »',
    action_product_draft: 'a désactivé le produit « {{subject}} »',
    action_product_archived: 'a archivé le produit « {{subject}} »',
    action_category_created: 'a créé la catégorie « {{subject}} »',
    action_category_revised: 'a modifié la catégorie « {{subject}} »',
    action_category_archived: 'a archivé la catégorie « {{subject}} »',
    action_location_created: 'a ajouté le dépôt « {{subject}} »',
    action_location_archived: 'a archivé le dépôt « {{subject}} »',
    action_order_settings_revised: 'a changé le délai de confirmation des commandes',
    action_tenant_profile_revised: 'a modifié les informations de la boutique {{subject}}',
    action_tenant_branding_revised: 'a modifié le logo et les couleurs de la boutique',
    field_defaultLocale: 'Langue par défaut',
    field_timezone: 'Fuseau horaire',
    field_logoMediaId: 'Logo',
    field_primaryColor: 'Couleur principale',
    field_secondaryColor: 'Couleur secondaire',
    field_accentColor: 'Couleur d’accent',
    action_expense_created: 'a ajouté la dépense « {{subject}} »',
    action_expense_revised: 'a modifié la dépense « {{subject}} »',
    action_expense_archived: 'a archivé la dépense « {{subject}} »',
    action_expense_restored: 'a rétabli la dépense « {{subject}} »',
    field_other: 'Autre information',
    field_displayName: 'Nom',
    field_preset: 'Accès',
    field_subsidiaryId: 'Filiale',
    field_status: 'Statut',
    field_name: 'Nom',
    field_taxId: 'Matricule fiscal',
    field_phone: 'Téléphone',
    field_address: 'Adresse',
    field_city: 'Ville',
    field_archived: 'Archivée',
    field_reference: 'Référence',
    field_categoryId: 'Catégorie',
    field_price: 'Prix',
    field_compareAtPrice: 'Prix barré',
    field_variantCount: 'Nombre de variantes',
    field_parentId: 'Catégorie parente',
    field_code: 'Code',
    field_isDefault: 'Dépôt par défaut',
    field_orderConfirmationTtlHours: 'Délai de confirmation',
    field_amount: 'Montant',
    field_spentOn: 'Date de la dépense',
    status_draft: 'Inactif',
    status_active: 'Actif',
    status_archived: 'Archivé',
    status_paused: 'Suspendu',
    status_removed: 'Retiré',
    value_yes: 'Oui',
    value_no: 'Non',
    value_none: 'Aucun',
    value_other: 'Supprimé ou archivé',
  },
  labels: {
    firstProducts: 'Seuls les {{max}} premiers produits sélectionnés sont préparés pour les étiquettes.',
    title: 'Étiquettes',
    context: 'Imprimez des étiquettes avec code-barres ou QR pour les variantes choisies.',
    printLabels: 'Imprimer des étiquettes',
    printFor: 'Imprimer les étiquettes de {{name}}',
    format: 'Format',
    format_sheet: 'Planche A4 (24 × 70 × 37 mm)',
    format_roll: 'Rouleau (50 × 30 mm)',
    symbology: 'Code',
    symbology_code128: 'Code-barres',
    symbology_qr: 'QR code',
    showPrice: 'Afficher le prix',
    startAt: 'Commencer à la position',
    startAtHelp: 'De 1 à {{count}}, pour réutiliser une planche entamée.',
    copiesOf: 'Nombre d’étiquettes pour {{name}}',
    summary: 'Étiquettes : {{stickers}} · Pages : {{pages}}',
    print: 'Imprimer',
    tooMany: '{{max}} étiquettes au maximum par impression. Réduisez les quantités.',
    unprintable:
      '{{count}} variante(s) n’auront pas de code imprimé : leur référence est trop longue ou contient des caractères non pris en charge. Choisissez le QR code.',
    preview: 'Aperçu de la première page',
    previewEmpty: 'Indiquez au moins une étiquette pour voir l’aperçu.',
    nothing: 'Aucun produit choisi',
    nothingHint: 'Sélectionnez des produits dans la liste, puis choisissez « Imprimer des étiquettes ».',
    chooseProducts: 'Choisir des produits',
    loading: 'Préparation des étiquettes',
    codeUnsupported: 'Code non imprimable',
    codeTooLong: 'Code trop long',
  },
  notifications: {
    filterLegend: 'Afficher',
    filter_all: 'Toutes',
    filter_unread: 'Non lues',
    sectionNew: 'Nouvelles',
    sectionEarlier: 'Plus anciennes',
    seePrevious: 'Voir les notifications précédentes',
    seeAll: 'Voir toutes les notifications',
    pageContext: 'Alertes de stock et de transporteur, et récapitulatif quotidien de 8 h.',
    allRead: 'Aucune notification non lue',
    allReadHelp: 'Les nouvelles alertes apparaîtront ici.',
    title: 'Notifications',
    bell: 'Notifications',
    bellUnseen: 'Notifications, {{count}} nouvelles',
    announce: 'Nouvelles notifications : {{count}}',
    markAllRead: 'Tout marquer comme lu',
    unread: 'Non lue',
    empty: 'Rien à signaler',
    emptyHelp:
      'Les alertes de stock et de transporteur, ainsi que le récapitulatif quotidien de 8 h, apparaîtront ici.',
    unknownReason: 'raison non précisée',
    stock_low_title: 'Stock bas : {{product}}',
    stock_low_detail: '{{sku}} à {{depot}} : il en reste {{available}} (seuil {{threshold}}).',
    stock_out_title: 'Rupture de stock : {{product}}',
    stock_out_detail: '{{sku}} n’est plus disponible à {{depot}}.',
    dispatch_failed_title: 'Colis refusé : {{number}}',
    dispatch_failed_detail: 'Le transporteur n’a pas enregistré le colis : {{reason}}',
    carrier_canceled_title: 'Colis annulé par le transporteur : {{number}}',
    carrier_canceled_detail: 'Vérifiez la commande et renvoyez-la si besoin.',
    daily_digest_title: 'Récapitulatif du {{day}}',
    digest_missing: 'Manquants : {{count}}',
    digest_deliveryFailed: 'Échecs de livraison : {{count}}',
    digest_returnsToReceive: 'Retours à réceptionner : {{count}}',
  },
  orderBulk: {
    cancel: 'Annuler les commandes',
    cancelHereOnly:
      'Ces commandes ne sont pas encore chez un transporteur : elles sont annulées ici seulement.',
    title_cancel: 'Annulation groupée',
    cancelTitle: 'Annuler les commandes sélectionnées : {{count}}',
    cancelMessage:
      'Le stock réservé redevient disponible. Une commande annulée ne peut plus être reprise. Celles qui ne peuvent pas l’être sont listées ensuite, avec la raison.',
    cancelAtCarrier:
      'Colis déjà remis au transporteur : {{count}}. Ils sont aussi supprimés chez lui, tant qu’il ne les a pas enlevés.',
    cancelConfirm: 'Annuler les commandes ({{count}})',
    keepOrders: 'Garder les commandes',
    handedOver: 'Remises au transporteur : {{count}}',
    awaitingCarrier: 'En attente de la réponse du transporteur : {{count}}',
    retryDispatch: 'Réessayer la remise ({{count}})',
    nothingEligible: 'Aucune commande sélectionnée ne permet cette action.',
    working: 'Traitement en cours…',
    notFoundTitle: 'Colis introuvables',
    notReadyTitle: 'Étiquettes pas encore disponibles : le transporteur n’a pas encore enregistré ces colis',
    separateTitle: 'Étiquettes fournies par le transporteur, à télécharger une par une',
    printPdf: 'Imprimer',
    downloadPdf: 'Télécharger le PDF',
    pdfReady: 'Étiquettes dans le PDF : {{count}}',
    skipped: 'Ignorées (statut incompatible) : {{count}}',
    refusedTitle: 'Commandes non traitées',
    refused: 'Non traitées : {{count}}',
    done: 'Traitées : {{count}}',
    title_labels: 'Impression des étiquettes',
    title_dispatch: 'Remise groupée au transporteur',
    title_confirm: 'Confirmation groupée',
    printLabels: 'Imprimer les étiquettes',
    clear: 'Tout désélectionner',
    selected: 'Commandes sélectionnées : {{count}}',
    label: 'Actions sur la sélection',
    dispatch: 'Remettre au transporteur',
    dispatchTitle: 'Remise au transporteur : {{count}} commandes',
    dispatchMessage:
      'Chaque commande est remise au transporteur choisi. Celles qui ne peuvent pas l’être sont listées ensuite, avec la raison.',
    confirm: 'Confirmer',
  },
  orderExport: {
    title: 'Exporter les commandes',
    count_one: '{{total}} commande',
    count_other: '{{total}} commandes',
    format:
      'Fichier CSV en français, compatible avec Excel et Google Sheets. Les dates sont exprimées dans le fuseau horaire de la boutique.',
    masked:
      'Les noms et les téléphones des clients seront masqués, et les adresses retirées : votre accès ne comprend pas les données clients.',
    prepare: 'Préparer le fichier',
    preparing: 'Préparation…',
    building: 'Préparation du fichier en cours. Vous pouvez continuer à travailler.',
    ready_one: 'Le fichier est prêt : {{total}} commande.',
    ready_other: 'Le fichier est prêt : {{total}} commandes.',
    failed: 'La préparation du fichier a échoué. Réessayez dans un instant.',
    retry: 'Réessayer',
    download: 'Télécharger le fichier',
  },
  orders: {
    dispatchFee: 'Frais de livraison',
    dispatchFeeOf: 'Frais de livraison de {{number}}',
    dispatchFeeInvalid: 'Saisissez un montant positif avec au plus 3 décimales.',
    dispatchCollect: 'À encaisser : {{amount}}',
    carrierFeeMissing: 'Aucun tarif défini pour ce transporteur : saisissez les frais.',
    selectAll: 'Sélectionner toutes les commandes affichées',
    selectRow: 'Sélectionner {{number}}',
    labelPrinted: 'Étiquette imprimée',
    refreshNotFollowed: 'Ce colis n’est plus suivi par le transporteur.',
    refreshQueued: 'Demande envoyée au transporteur ; le statut se mettra à jour dans un instant.',
    refresh: 'Actualiser le suivi',
    view_canceled: 'Annulées',
    view_exchanges: 'Échanges',
    view_returns: 'Retours',
    view_to_receive: 'À réceptionner',
    view_delivered: 'Livrées',
    view_missing: 'Manquants',
    view_in_delivery: 'Chez le transporteur',
    view_printed: 'Imprimées',
    view_to_print: 'À imprimer',
    view_confirmed: 'À expédier',
    backToAllOrders: 'Revenir à toutes les commandes',
    moreViews: 'Plus de vues',
    view_to_confirm: 'À confirmer',
    context: 'Confirmez, expédiez et suivez chaque colis jusqu’à l’encaissement.',
    column_order: 'Commande',
    column_items: 'Articles',
    column_cod: 'À encaisser',
    column_carrier: 'Transporteur',
    column_barcode: 'Code-barres',
    barcodeNone: '—',
    itemCount_one: '{{count}} article',
    itemCount_other: '{{count}} articles',
    filters: 'Filtres de la liste',
    filter_carrier: 'Transporteur',
    filter_city: 'Ville',
    filter_date: 'Date',
    filter_remove: 'Retirer le filtre {{name}}',
    carrierUnassigned: 'Non attribué',
    searchLabel: 'Rechercher une commande',
    searchPlaceholder: 'N° de commande, suivi ou téléphone',
    sortedNewest: 'Triées par date, plus récentes d’abord',
    searchScope: 'Les 5 commandes les plus pertinentes',
    noSearchMatch: 'Aucune commande ne correspond',
    noSearchMatchHelp: 'Vérifiez le numéro, le suivi ou le téléphone.',
    export: 'Exporter',
    newOrder: 'Nouvelle commande',
    number: 'N° de commande',
    customer: 'Client',
    phone: 'Téléphone',
    destination: 'Destination',
    total: 'Total',
    status: 'Statut',
    createdAt: 'Créée le',
    status_PENDING: 'En attente',
    status_CONFIRMED: 'Confirmée',
    status_CANCELED: 'Annulée',
    payment_COD_PENDING: 'À encaisser',
    payment_VOID: 'Annulé',
    status_DISPATCH_REQUESTED: 'Envoi au transporteur en cours',
    status_DISPATCHED: 'Expédiée',
    status_IN_TRANSIT: 'En transit',
    status_OUT_FOR_DELIVERY: 'En cours de livraison',
    status_DELIVERED: 'Livrée',
    status_DELIVERY_FAILED: 'Livraison échouée',
    status_RETURNING: 'Retour en cours',
    status_RETURNED: 'Retournée',
    status_RETURN_RECEIVED: 'Retour réceptionné',
    payment_COD_COLLECTED: 'Encaissé',
    payment_SETTLED: 'Versé',
    payment_DISPUTED: 'En litige',
    dispatch: 'Expédier',
    dispatching: 'Envoi…',
    dispatchTitle: 'Expédier la commande {{number}}',
    dispatchMessage:
      'Choisissez le transporteur. Le stock réservé sera sorti dès qu’il aura enregistré le colis.',
    dispatchRequested: 'Commande {{number}} envoyée au transporteur',
    dispatchFailed: 'Dernier envoi refusé : {{reason}}',
    carrierMessage: 'Message du transporteur : « {{message}} »',
    carrierStatus: 'Statut transporteur',
    carrierStatusNone: '—',
    carrierStatusLine: '{{status}} · mis à jour {{when}}',
    noCarrier: 'Aucun transporteur n’est configuré pour votre boutique.',
    configureCarriers: 'Configurer les transporteurs',
    carrier: 'Transporteur',
    shipment: 'Expédition',
    carrierReference: 'N° BL transporteur',
    trackingNumber: 'N° de suivi',
    trackingPending: 'En attente du transporteur',
    labelPrint: 'Imprimer l’étiquette',
    labelPrintFailed: 'Impossible d’ouvrir l’impression. Réessayez ou téléchargez l’étiquette.',
    labelDownload: 'Télécharger',
    labelPreparing: 'Préparation…',
    labelDownloaded: 'Étiquette téléchargée',
    fillSender: 'Renseigner l’expéditeur',
    view: 'Afficher',
    view_all: 'Toutes',
    noOrders: 'Aucune commande pour l’instant',
    noOrdersHelp: 'Créez votre première commande à partir d’un client.',
    noMatch: 'Aucune commande dans cette vue',
    noMatchHelp: 'Changez de vue ou créez une commande.',
    lines: 'Articles',
    quantity: 'Quantité',
    unitPrice: 'Prix unitaire',
    lineTotal: 'Total ligne',
    itemsSubtotal: 'Sous-total articles',
    shippingFee: 'Frais de livraison',
    totalAmount: 'Total',
    codAmount: 'À encaisser à la livraison',
    delivery: 'Livraison',
    address: 'Adresse',
    governorate: 'Gouvernorat',
    delegation: 'Délégation',
    postalCode: 'Code postal',
    company: 'Société',
    depot: 'Dépôt',
    exchange: 'Échange',
    exchangeHelp: 'Le livreur récupère un article en retour.',
    note: 'Commentaire',
    history: 'Historique',
    historyCreated: 'Créée',
    masked: 'Les données personnelles sont masquées pour votre rôle.',
    confirm: 'Confirmer',
    reopen: 'Remettre en attente',
    cancel: 'Annuler la commande',
    confirmed: 'Commande {{number}} confirmée',
    reopened: 'Commande {{number}} remise en attente',
    canceled: 'Commande {{number}} annulée',
    cancelTitle: 'Annuler la commande {{number}} ?',
    cancelMessage: 'Le stock réservé redevient disponible. Une commande annulée ne peut plus être reprise.',
    cancelAtCarrier:
      'Le colis sera aussi annulé chez {{carrier}}. Ce n’est plus possible une fois qu’il l’a pris en charge.',
    cancelReason: 'Motif',
    keepOrder: 'Garder la commande',
    reason_out_of_stock: 'Rupture de stock',
    reason_unreachable: 'Client injoignable',
    reason_customer_declined: 'Refus du client',
    reason_fraud_suspected: 'Suspicion de fraude',
    reason_duplicate: 'Commande en double',
    reason_other: 'Autre',
    reason_unconfirmed_expired: 'Non confirmée à temps',
    reason_carrier_canceled: 'Annulée chez le transporteur',
    edit: 'Modifier',
    historyAmended: 'Modifiée : {{fields}}',
    historyPayment: 'Paiement : {{status}}',
    field_shipping: 'adresse',
    field_lines: 'articles',
    field_shippingFee: 'frais de livraison',
    field_note: 'commentaire',
    field_customer: 'client',
    field_isExchange: 'échange',
    field_subsidiaryId: 'société',
    source: 'Source de la commande',
    sourceHelp: 'Canal d’acquisition du client, utilisé dans les statistiques par canal.',
    source_none: 'Non précisée',
    source_facebook: 'Facebook',
    source_instagram: 'Instagram',
    source_tiktok: 'TikTok',
    source_whatsapp: 'WhatsApp',
    source_phone: 'Téléphone',
    source_other: 'Autre',
    field_source: 'source',
  },
  newOrder: {
    feeAtDispatch: 'Les frais de livraison sont ajoutés à l’expédition, selon le transporteur choisi.',
    context: 'Choisissez la société, les articles puis le client ; le stock est réservé à la création.',
    customerSection: 'Client',
    customerSearch: 'Client',
    customerPlaceholder: 'Choisir un client ou saisir son téléphone',
    customerByPhoneOnly: 'Saisissez le numéro complet pour retrouver un client, ou créez-le.',
    noCustomerFound: 'Aucun client avec ce numéro.',
    createCustomer: 'Créer un client',
    createCustomerNamed: 'Créer le client « {{text}} »',
    changeCustomer: 'Changer de client',
    deliverySection: 'Livraison',
    selectGovernorate: 'Choisir un gouvernorat',
    anyDelegation: 'Non précisée',
    itemsSection: 'Articles',
    searchProducts: 'Rechercher ou scanner un produit',
    productPlaceholder: 'Nom, référence ou code-barres',
    productHelp: 'Appuyez sur Entrée pour ajouter directement un produit scanné.',
    scanAdded: '{{name}} ajouté',
    scanOtherCompany: '{{name}} appartient à une autre société.',
    scanOutOfStock: '{{name}} n’est plus en stock dans ce dépôt.',
    scanArchived: 'Ce produit est archivé ; il ne peut pas être commandé.',
    noProducts: 'Aucun produit trouvé.',
    add: 'Ajouter',
    added: 'Ajouté',
    available: 'Disponible : {{quantity}}',
    remove: 'Retirer',
    noLines: 'Ajoutez au moins un article.',
    summarySection: 'Récapitulatif',
    create: 'Créer la commande',
    creating: 'Création…',
    created: 'Commande {{number}} créée',
    customerRequired: 'Choisissez un client.',
    addressRequired: 'L’adresse est obligatoire.',
    governorateRequired: 'Choisissez un gouvernorat.',
    quantityInvalid: 'Saisissez un nombre entier de 1 à 10 000.',
    amountInvalid: 'Saisissez un montant positif avec au plus 3 décimales.',
    itemsHint: 'Recherchez ou scannez, puis ajustez les quantités et les prix.',
    emptyLinesHint: 'Les articles ajoutés apparaissent ici avec leur quantité et leur prix.',
    customerHint: 'Choisissez un client existant ou créez-le en quelques secondes.',
    deliveryHint: 'L’adresse remise au transporteur et le dépôt qui prépare le colis.',
    optionsSection: 'Options',
    optionsHint: 'Canal de vente, échange et consignes pour le livreur.',
    sectionComplete: 'Complété',
    readinessTitle: 'Avant de créer',
    readyItems: 'Au moins un article',
    readyCustomer: 'Un client choisi',
    readyDelivery: 'Une adresse et un gouvernorat',
    stepDone: 'fait',
    stepTodo: 'à faire',
    unitsCount: 'Unités',
    decreaseQuantity: 'Diminuer la quantité',
    increaseQuantity: 'Augmenter la quantité',
  },
  errors: {
    DEPENDENCY_UNAVAILABLE:
      'Un service dont la boutique dépend ne répond pas. Réessayez dans quelques minutes.',
    TENANT_SUBSIDIARY_NAME_TAKEN: 'Une filiale porte déjà ce nom.',
    TEAM_MEMBER_EXISTS: 'Cette personne fait déjà partie de l’équipe.',
    TEAM_LAST_ADMIN: 'La boutique doit garder au moins un administrateur actif.',
    TEAM_SELF_CHANGE: 'Vous ne pouvez pas modifier votre propre accès. Demandez à un autre administrateur.',
    DASHBOARD_VIEW_LIMIT_REACHED:
      'Vous pouvez garder jusqu’à 10 vues du tableau de bord. Supprimez-en une pour en enregistrer une autre.',
    DASHBOARD_VIEW_NAME_TAKEN: 'Vous avez déjà une vue avec ce nom. Choisissez un autre nom.',
    TEAM_GRANT_NOT_ALLOWED: 'Seul un administrateur peut donner cet accès.',
    UNKNOWN: 'Une erreur est survenue. Réessayez dans un instant.',
    SHIPPING_CARRIER_AUTH_FAILED:
      'Le transporteur a refusé les identifiants du compte. Vérifiez-les dans Paramètres puis réessayez.',
    SHIPPING_CARRIER_NOT_CONFIGURED:
      'Ce transporteur n’est pas configuré ou il est désactivé. Vérifiez-le dans Paramètres puis réessayez.',
    SHIPPING_CANCEL_UNSUPPORTED:
      'Ce transporteur ne permet pas d’annuler en ligne. Appelez-le pour annuler le colis.',
    SHIPPING_CANCEL_REFUSED:
      'Le transporteur a déjà pris le colis en charge et refuse l’annulation. Traitez-le comme un retour.',
    SHIPPING_UPDATE_REFUSED:
      'Le transporteur refuse la modification : le colis est peut-être déjà enlevé. Rien n’a été changé.',
    SHIPPING_UPDATE_UNSUPPORTED:
      'Ce transporteur ne permet pas de modifier un colis déjà expédié. Rien n’a été changé.',
    SHIPPING_CARRIER_VALIDATION_FAILED:
      'Le transporteur a refusé le colis. Vérifiez l’adresse et le téléphone du client puis réessayez.',
    SHIPPING_DISPATCH_UNCERTAIN:
      'Le transporteur a peut-être déjà créé le colis. Vérifiez sur son portail avant d’expédier à nouveau, sinon il y aura un doublon.',
    ORDERS_CANCEL_IN_PROGRESS:
      'L’annulation est en cours chez le transporteur, la commande se mettra à jour d’elle-même.',
    SHIPPING_CARRIER_UNAVAILABLE: 'Le transporteur ne répond pas. Réessayez dans quelques minutes.',
    SHIPPING_HANDOVER_DUPLICATE: 'Ce colis est déjà remis au transporteur.',
    SHIPPING_HANDOVER_REFUSED: 'Ce colis ou cette remise ne peut pas être utilisé ici.',
    SHIPPING_LABEL_NOT_READY: 'L’étiquette est en préparation. Réessayez dans quelques secondes.',
    SHIPPING_SENDER_MISSING:
      'Renseignez l’expéditeur de la boutique dans Paramètres pour pouvoir imprimer les étiquettes.',
    SHIPPING_UNREACHABLE: 'Le service d’expédition ne répond pas. Réessayez dans quelques minutes.',
    AUTH_ROLE_REQUIRED: 'Votre rôle ne permet pas cette action.',
    CATALOG_CATEGORY_CYCLE: 'Une catégorie ne peut pas être son propre parent.',
    CATALOG_CATEGORY_NOT_EMPTY: 'Cette catégorie contient encore des sous-catégories ou des produits.',
    CATALOG_REFERENCE_TAKEN: 'Cette référence est déjà utilisée par un autre produit.',
    CATALOG_OPTION_TAKEN: 'Ce nom est déjà utilisé ; choisissez-le dans la liste.',
    CATALOG_OPTION_RESERVED:
      'La provenance est gérée par la plateforme : choisissez Local ou Importé avec son pays.',
    CATALOG_VARIANT_IN_USE:
      'Cette variante a déjà des mouvements de stock : elle ne peut pas être supprimée.',
    CATALOG_SLUG_TAKEN: 'Ce nom génère une adresse web déjà utilisée. Choisissez-en un autre.',
    CATALOG_TRANSLATION_MISSING: 'La traduction dans la langue par défaut est obligatoire.',
    CONCURRENCY_CONFLICT: 'Quelqu’un a modifié cet élément pendant votre saisie. Rechargez puis réessayez.',
    FEATURE_NOT_ENTITLED: 'Cette fonctionnalité n’est pas incluse dans votre offre.',
    INVENTORY_INITIAL_STOCK_EXISTS: 'Cette variante a déjà du stock : ajustez-le par un mouvement.',
    INVENTORY_INSUFFICIENT_STOCK: 'Stock insuffisant dans ce dépôt.',
    INVENTORY_LOCATION_ARCHIVED: 'Ce dépôt est archivé et n’accepte plus de mouvements.',
    INVENTORY_LOCATION_NOT_EMPTY:
      'Ce dépôt contient encore du stock : déplacez ou sortez ses unités avant de l’archiver.',
    INVENTORY_DEFAULT_LOCATION_REQUIRED:
      'La boutique garde toujours un dépôt par défaut : choisissez-en un autre avant de modifier celui-ci.',
    MEDIA_TYPE_NOT_ALLOWED: 'Ce type de fichier n’est pas accepté ici.',
    MEDIA_TOO_LARGE: 'Cette image dépasse la taille autorisée.',
    MEDIA_IMAGE_TOO_LARGE: 'Cette image a trop de pixels : réduisez-la avant de l’envoyer.',
    MEDIA_UPLOAD_INCOMPLETE: 'L’envoi n’a pas abouti. Réessayez.',
    MEDIA_CHECKSUM_MISMATCH: 'Le fichier a été modifié pendant l’envoi. Réessayez.',
    MEDIA_MALWARE_DETECTED: 'Ce fichier a été bloqué par l’analyse de sécurité.',
    MEDIA_PROCESSING_FAILED: 'L’image n’a pas pu être traitée. Réessayez.',
    MEDIA_UPLOAD_EXPIRED: 'L’envoi a expiré. Ajoutez l’image à nouveau.',
    MEDIA_NOT_READY: 'Une image est encore en cours de traitement. Patientez puis enregistrez.',
    RATE_LIMITED: 'Trop de requêtes. Patientez quelques secondes puis réessayez.',
    RESOURCE_CONFLICT: 'Cet élément existe déjà.',
    RESOURCE_NOT_FOUND: 'Cet élément est introuvable.',
    STATE_TRANSITION_INVALID: 'Ce changement de statut n’est pas autorisé.',
    VALIDATION_FAILED: 'Certains champs sont invalides. Corrigez-les puis réessayez.',
    CRYPTO_INTEGRITY_FAILED:
      'Cette fiche est illisible. Contactez le support en précisant l’heure de l’erreur.',
    CRYPTO_UNAVAILABLE:
      'Les données personnelles sont momentanément indisponibles. Réessayez dans un instant.',
    ORDERS_CUSTOMER_PHONE_TAKEN: 'Un client utilise déjà ce numéro.',
    IDEMPOTENCY_KEY_REUSED:
      'Cette commande a changé depuis le premier envoi. Rechargez la page puis réessayez.',
    ORDERS_NOT_EDITABLE:
      'Cette commande a déjà été remise au transporteur ou annulée ; elle ne peut plus être modifiée.',
    ORDERS_EXPORT_TOO_LARGE:
      'Trop de commandes pour un seul fichier. Choisissez une vue ou ajoutez un filtre (date, transporteur, ville), puis réessayez.',
    ORDERS_RETURN_NOT_EXPECTED:
      'Ce colis n’est pas attendu en retour. Vérifiez son statut dans les commandes.',
    ORDERS_LINE_INVALID:
      'Un article ne peut pas être vendu (inconnu, archivé ou en double). Retirez-le puis réessayez.',
  },
  statistics: {
    title: 'Statistiques',
    context: 'Comprenez où vous gagnez et où vous perdez de l’argent, étape par étape.',
    tab_delivery: 'Livraison',
    tab_confirmation: 'Confirmation',
    tab_products: 'Produits',
    tab_orders: 'Commandes',
    tab_marketing: 'Marketing',
    scope_delivery: 'Colis enlevés du {{from}} au {{to}}.',
    scope_confirmation: 'Commandes reçues du {{from}} au {{to}}, selon leur traitement par l’équipe.',
    scope_products: 'Unités des commandes reçues du {{from}} au {{to}}.',
    scope_orders: 'Commandes reçues du {{from}} au {{to}}.',
    scope_marketing: 'Commandes reçues du {{from}} au {{to}}, par source.',
    carrierFilter: 'Transporteur',
    allCarriers: 'Tous les transporteurs',
    value: 'Valeur',
    margin: 'Bénéfice',
    parcel_depot: 'Au dépôt du transporteur',
    parcel_transit: 'En transit',
    parcel_delivered: 'Livrés',
    parcel_failed: 'Livraison échouée',
    parcel_returned: 'Retournés',
    delayTitle: 'Délai de livraison',
    delayHelp: 'Délai moyen, de l’enlèvement à la livraison',
    delayBand_1: 'Le lendemain',
    delayBand_2: '2 jours',
    delayBand_3: '3 jours',
    delayBand_4: '4 jours et plus',
    performanceTitle: 'Performance de livraison',
    performanceHelp: 'Sur {{parcels}} colis arrivés au bout de leur parcours',
    carriersTitle: 'Comparaison des transporteurs',
    carrier: 'Transporteur',
    parcels: 'Colis',
    deliveryRate: 'Taux de livraison',
    averageDelay: 'Délai moyen',
    owed: 'À encaisser',
    noParcels: 'Aucun colis enlevé sur cette période',
    days: '{{value}} j',
    minutes: '{{minutes}} min',
    hoursMinutes: '{{hours}} h {{minutes}}',
    mapTitle: 'Taux de livraison par gouvernorat',
    mapLow: 'Moins de 65 %',
    mapHigh: '87 % et plus',
    mapLabelAll: 'Carte de la Tunisie par gouvernorat',
    mapLabel: '{{name}}, {{rate}}',
    mapNoParcels: '{{name}}, aucun colis',
    mapHint: 'Survolez ou parcourez un gouvernorat pour voir ses chiffres.',
    mapRank: '{{rank}}e sur {{total}} gouvernorats',
    mapSearch: 'Chercher un gouvernorat',
    bestCarrier: 'Meilleur transporteur',
    confirmation_received: 'Commandes reçues',
    confirmation_handled: 'Traitées',
    confirmation_confirmed: 'Confirmées',
    confirmation_rejected: 'Rejetées',
    confirmation_pending: 'En attente',
    confirmation_delivered: 'Livrées ensuite',
    confirmation_returned: 'Retournées ensuite',
    confirmationRatesTitle: 'Taux de confirmation',
    netConfirmation: 'Net (commandes traitées)',
    globalConfirmation: 'Global (commandes reçues)',
    responsivenessTitle: 'Réactivité de l’équipe',
    confirmationDelayHelp: 'Délai moyen entre la réception et la confirmation',
    agentsTitle: 'Taux de confirmation par agent',
    agentsHelp: 'La livraison des commandes confirmées mesure la qualité de la confirmation.',
    agent: 'Agent',
    formerMember: 'Ancien membre',
    handled: 'Traitées',
    confirmationRate: 'Confirmation',
    deliveredAfter: 'Livrées ensuite',
    confirmationDelay: 'Délai',
    noDecisions: 'Aucune commande traitée sur cette période',
    reasonsTitle: 'Motifs de rejet',
    noRejection: 'Aucune commande rejetée sur cette période.',
    units_all: 'Unités commandées',
    units_pending: 'En attente',
    units_confirmed: 'Confirmées',
    units_rejected: 'Rejetées',
    units_depot: 'Au dépôt',
    units_transit: 'En transit',
    units_delivered: 'Livrées',
    units_returned: 'Retournées',
    orders_all: 'Commandes reçues',
    orders_pending: 'En attente',
    orders_confirmed: 'Confirmées',
    orders_rejected: 'Rejetées',
    orders_depot: 'Au dépôt',
    orders_transit: 'En transit',
    orders_delivered: 'Livrées',
    orders_returned: 'Retournées',
    productsTitle: 'Rentabilité par produit',
    productsHelp: 'Triée par bénéfice livré.',
    purchaseTotal: 'Total achat',
    groupBy: 'Regrouper par',
    byVariant: 'Variante',
    optionTitle: 'Rentabilité par {{option}}',
    optionHelp: 'Triée par bénéfice livré, toutes variantes confondues.',
    noOptionValue: 'Sans valeur',
    product: 'Produit',
    unitsDelivered: 'Unités livrées',
    revenue: 'Chiffre d’affaires',
    unitsReturned: 'Retours',
    noProducts: 'Aucune unité commandée sur cette période',
    campaignsLater:
      'Le détail par campagne et par publicité arrive avec la boutique en ligne. La source choisie à la création d’une commande alimente déjà ce tableau.',
    channelsTitle: 'Performance par canal',
    channelsHelp: 'Source indiquée sur la commande.',
    channel: 'Canal',
    orders: 'Commandes',
    noOrders: 'Aucune commande sur cette période',
  },
  calculator: {
    title: 'Calculateur de rentabilité',
    context:
      'Simulez un produit avant de lancer vos publicités. Les résultats se mettent à jour pendant la saisie.',
    reset: 'Réinitialiser',
    useRealRates: 'Utiliser mes taux réels',
    group_product: 'Votre produit',
    group_productHelp: 'Partez d’un produit du catalogue ou saisissez librement.',
    group_advertising: 'Publicité',
    group_advertisingHelp: 'Votre coût d’acquisition des prospects.',
    group_delivery: 'Livraison',
    group_deliveryHelp: 'Les tarifs de votre transporteur.',
    group_rates: 'Vos taux',
    group_ratesHelp: 'Saisissez vos taux ou utilisez ceux de vos 30 derniers jours.',
    field_cost: 'Coût d’achat',
    field_price: 'Prix de vente',
    field_priceHelp: 'Livraison incluse, soit le montant encaissé.',
    field_leadCost: 'Coût par prospect',
    field_leads: 'Prospects reçus',
    field_deliveryFee: 'Par colis livré',
    field_returnFee: 'Par colis retourné',
    field_preparationFee: 'Préparation',
    field_preparationFeeHelp: 'Par commande confirmée.',
    field_confirmationRate: 'Taux de confirmation',
    field_deliveryRate: 'Taux de livraison',
    units: 'unités',
    issue_invalid: 'Saisissez un nombre positif, par exemple 3,5.',
    issue_aboveHundred: 'Un taux ne peut pas dépasser 100 %.',
    productSearch: 'Partir d’un produit',
    productSearchButton: 'Chercher',
    productPick: '{{name}} · {{sku}} · {{price}}',
    productNone: 'Aucun produit actif ne correspond.',
    resultTitle: 'Résultat estimé',
    profit: 'Bénéfice net estimé',
    loss: 'Perte estimée',
    perDelivered: '{{amount}} par colis livré',
    margin: 'marge {{value}}',
    incomplete: 'Le résultat attend vos chiffres',
    incompleteHelp: 'Corrigez les champs signalés pour voir le résultat.',
    funnelTitle: 'Du prospect à l’encaissement',
    funnel_leads: 'Prospects',
    funnel_confirmed: 'Confirmées',
    funnel_delivered: 'Livrées',
    funnel_returned: 'Retournées',
    splitTitle: 'Où va votre chiffre d’affaires · {{revenue}}',
    split_productCost: 'Coût produit',
    split_delivery: 'Livraison',
    split_returns: 'Retours',
    split_preparation: 'Préparation',
    split_advertising: 'Publicité',
    split_profit: 'Bénéfice',
    advertisingPerDelivered: 'Coût publicitaire par colis livré',
    breakEven: 'Coût par prospect maximum',
    tipGain: 'Si votre taux de livraison gagne {{points}} points, votre bénéfice augmente de {{gain}}.',
    tipBreakEven: 'Au-delà de {{amount}} par prospect, ce produit vous fait perdre de l’argent.',
    realRatesApplied:
      'Vos taux des 30 derniers jours : confirmation {{confirmation}} %, livraison {{delivery}} %.',
    realRatesMissing:
      'Pas assez de commandes sur 30 jours pour l’un des taux ; la valeur saisie est conservée.',
  },
  setup: {
    title: 'Configuration de la boutique',
    stepsLabel: 'Étapes de la configuration',
    exit: 'Terminer plus tard',
    back: 'Retour',
    skip: 'Passer cette étape',
    start: 'Commencer',
    continue: 'Continuer',
    finish: 'Commencer à vendre',
    saving: 'Enregistrement…',
    saved: 'Enregistré automatiquement',
    finished: 'Votre boutique est configurée.',
    step_welcome: 'Bienvenue',
    step_welcomeHelp: 'Le parcours en bref',
    step_store: 'Votre boutique',
    step_storeHelp: 'Nom, langue, fuseau horaire',
    step_storeCard: 'Nom, langue, pays et fuseau horaire.',
    step_brand: 'Votre marque',
    step_brandHelp: 'Logo et couleurs',
    step_brandCard: 'Logo et couleurs sur vos étiquettes.',
    step_delivery: 'Livraison',
    step_deliveryHelp: 'Transporteur, expéditeur',
    step_deliveryCard: 'Transporteur et adresse d’expédition.',
    step_orders: 'Commandes',
    step_ordersHelp: 'Délai de confirmation',
    step_ordersCard: 'Délai de confirmation par téléphone.',
    welcomeTitle: 'Prêt à lancer votre activité ?',
    welcomeLead:
      'Cinq étapes courtes. Tout est enregistré au fur et à mesure, vous pouvez reprendre plus tard.',
    video: 'Vidéo de bienvenue',
    storeTitle: 'Les informations essentielles',
    storeLead: 'Elles servent aux montants, aux dates et aux messages envoyés à vos clients.',
    storeName: 'Nom de la boutique',
    storeNameHelp: 'Affiché sur les étiquettes et les bons de sortie.',
    storeNameInvalid: 'Saisissez un nom de 1 à 200 caractères.',
    language: 'Langue par défaut',
    languageHelp: 'Chaque membre de l’équipe peut choisir la sienne dans son profil.',
    country: 'Pays d’activité',
    countryValue: '{{country}} · {{currency}}',
    countryHelp: 'Le pays détermine la devise ; contactez le support pour le modifier.',
    timezone: 'Fuseau horaire',
    timezoneHelp: 'Sert au récapitulatif du matin et aux commandes du jour.',
    brandTitle: 'Votre identité visuelle',
    brandLead: 'Votre logo et vos couleurs apparaissent sur les étiquettes colis et les bons de sortie.',
    logo: 'Logo',
    logoDrop: 'Déposez votre logo ou choisissez un fichier',
    logoHelp: 'PNG, JPEG ou WebP, 2 Mo au plus.',
    logoRemove: 'Retirer le logo',
    logoUploading: 'Préparation du logo…',
    logoRefused: '« {{name}} » n’est pas une image PNG, JPEG ou WebP.',
    logoBusy: 'Patientez jusqu’à ce que le logo soit prêt avant de continuer.',
    logoAlt: 'Logo de la boutique',
    colors: 'Couleurs',
    color_primary: 'Principale',
    color_secondary: 'Secondaire',
    color_accent: 'Accent',
    colorReadable: 'Le texte blanc reste lisible.',
    colorLowContrast: 'Le texte blanc est peu lisible sur cette couleur.',
    colorInvalid: 'Format attendu : #RRGGBB.',
    colorSample: 'Aa',
    previewTitle: 'Aperçu de l’étiquette',
    previewRecipient: 'Destinataire',
    previewAmount: 'Montant à encaisser',
    previewSample: 'Amira T. · Sousse',
    deliveryTitle: 'Comment livrez-vous ?',
    deliveryLead: 'Connectez au moins un transporteur et indiquez l’expéditeur imprimé sur chaque colis.',
    senderTitle: 'Expéditeur des étiquettes',
    deliveryReadOnly: 'Seul un utilisateur autorisé à gérer les transporteurs peut modifier cette étape.',
    ordersTitle: 'Vos commandes',
    ordersLead:
      'Combien de temps une commande peut-elle attendre la confirmation par téléphone avant d’être annulée ?',
    window: 'Délai de confirmation',
    windowHours: '{{count}} heures',
    windowHelp_24: 'Pour les produits très demandés.',
    windowHelp_48: 'Recommandé pour la plupart des boutiques.',
    windowHelp_72: 'Pour les clients difficiles à joindre.',
    windowHelp_current: 'Votre réglage actuel.',
    summaryTitle: 'Récapitulatif',
    summaryBranded: 'Logo et couleurs enregistrés',
    summaryUnbranded: 'Pas encore définie',
    summaryNoCarrier: 'Aucun pour l’instant',
    trackTitle: 'Configurer votre boutique',
    trackSummary_one: 'Encore {{count}} étape pour être prêt à expédier.',
    trackSummary_other: 'Encore {{count}} étapes pour être prêt à expédier.',
    trackSummaryDone: 'Tout est prêt. Vous pouvez revoir chaque étape.',
    trackProgress: '{{done}} sur {{total}}',
    trackToggle: 'Afficher ou masquer les étapes',
    trackResume: 'Continuer la configuration',
    trackReview: 'Revoir la configuration',
  },
  settings: {
    context:
      'Tout ce qu’il faut pour expédier : vos transporteurs, vos étiquettes et les règles des commandes.',
  },

  editOrder: {
    title: 'Modifier la commande',
    titleOf: 'Modifier {{number}}',
    context: 'Adresse, articles, frais et commentaire ; le stock réservé suit les nouveaux articles.',
    save: 'Enregistrer',
    saving: 'Enregistrement…',
    saved: 'Commande {{number}} modifiée',
    discard: 'Annuler les modifications',
    back: 'Retour à la commande',
    notEditable: 'Cette commande ne peut plus être modifiée',
    notEditableHelp:
      'Les commandes en attente ou confirmées sont modifiables, ainsi que l’adresse d’un colis pas encore enlevé chez un transporteur qui accepte les modifications.',
    atCarrierHelp:
      'Le colis est chez {{carrier}} et pas encore enlevé : seules l’adresse de livraison et la note peuvent changer. La modification est envoyée à {{carrier}} ; si elle est refusée, rien ne change.',
    lockedItems: 'Articles (verrouillés après l’expédition)',
    sendToCarrier: 'Envoyer à {{carrier}}',
    savedAtCarrier: 'Commande {{number}} modifiée chez {{carrier}}',
    masked: 'Les coordonnées du client ne sont pas accessibles avec votre rôle',
    maskedHelp: 'Demandez l’accès aux données client pour modifier l’adresse.',
    archivedDepot: 'Dépôt archivé',
  },
  orderSettings: {
    hoursLong: '{{count}} heures',
    rule: 'Une commande qui n’est pas confirmée dans ce délai est annulée automatiquement, et ses articles sont remis en stock.',
    title: 'Annulation automatique',
    context: 'Libère le stock bloqué par des commandes que le client ne confirme jamais.',
    window: 'Délai de confirmation',
    windowHelp: 'En heures, de 1 à 720 (30 jours).',
    windowInvalid: 'Saisissez un nombre entier d’heures entre {{min}} et {{max}}.',
    edit: 'Modifier le délai',
    saved: 'Délai de confirmation enregistré',
  },
  expenses: {
    context:
      'Les dépenses de la boutique, par jour et par filiale. Elles réduisent le résultat net de la vue d’ensemble.',
    newTitle: 'Nouvelle dépense',
    editTitle: 'Modifier la dépense',
    name: 'Libellé',
    amount: 'Montant',
    spentOn: 'Date',
    subsidiary: 'Filiale',
    wholeShop: 'Toute la boutique',
    note: 'Note',
    nameRequired: 'Indiquez un libellé.',
    amountInvalid: 'Saisissez un montant valide.',
    dayRequired: 'Choisissez la date de la dépense.',
    archive: 'Archiver',
    restore: 'Restaurer',
    view: 'Afficher',
    view_active: 'Actives',
    view_archived: 'Archivées',
    none: 'Aucune dépense',
    noneHelp: 'Enregistrez le loyer, les emballages ou la publicité pour suivre le résultat net.',
    noneArchived: 'Aucune dépense archivée',
    saved: 'Dépense « {{name}} » enregistrée',
    archived: 'Dépense « {{name}} » archivée',
    restored: 'Dépense « {{name}} » restaurée',
  },
  finance: {
    section_expenses: 'Dépenses',
    kpiExpenses: 'Dépenses de la période',
    kpiNet: 'Résultat net',
    sections: 'Sections de la finance',
    section_overview: 'Vue d’ensemble',
    section_remittances: 'Relevés transporteurs',
    section_disputes: 'Litiges',
    context: 'Ce que chaque transporteur a encaissé, versé et doit encore à la boutique.',
    carrier: 'Transporteur',
    delivered: 'Livrés',
    remitted: 'Versés',
    carrierFees: 'Frais de livraison',
    returnFees: 'Frais de retour',
    awaiting: 'À verser',
    disputes: 'Litiges',
    kpiAwaiting: 'Encaissé, pas encore versé',
    kpiRemitted: 'Versé sur la période',
    kpiFees: 'Frais transporteurs sur la période',
    kpiDisputes: 'Litiges ouverts',
    noFigures: 'Aucun chiffre pour cette période',
    noFiguresHelp: 'Les colis livrés et les relevés importés apparaîtront ici.',
  },
  disputes: {
    context: 'Les colis dont le montant versé diffère du montant à encaisser.',
    view: 'Afficher',
    view_disputed: 'Ouverts',
    view_resolved: 'Résolus',
    trackingNumber: 'N° de suivi',
    carrier: 'Transporteur',
    expected: 'À encaisser',
    collected: 'Versé',
    difference: 'Écart',
    since: 'Depuis',
    status: 'État',
    status_settled: 'Réglé',
    status_disputed: 'En litige',
    status_resolved: 'Résolu',
    none: 'Aucun litige ouvert',
    noneHelp: 'Les écarts de montant détectés à l’import d’un relevé apparaîtront ici.',
    noneResolved: 'Aucun litige résolu',
    resolveTitle: 'Résoudre le litige {{trackingNumber}}',
    resolve: 'Résoudre',
    expectedWas: 'Montant à encaisser : {{amount}}',
    collectedAmount: 'Montant finalement versé',
    collectedHelp: 'Laissez vide si le montant reste inconnu.',
    amountInvalid: 'Saisissez un montant valide.',
    note: 'Note de résolution',
    noteHelp: 'Expliquez l’accord trouvé avec le transporteur.',
    noteRequired: 'Ajoutez une note de résolution.',
    resolved: 'Litige {{trackingNumber}} résolu',
  },
  remittances: {
    context:
      'Importez les relevés de versement des transporteurs : chaque colis est réglé, mis en litige ou signalé.',
    importTitle: 'Importer un relevé',
    import: 'Importer',
    carrier: 'Transporteur',
    noCarrier: 'Configurez d’abord un compte transporteur.',
    sourcePaste: 'Coller ou scanner',
    sourceCsv: 'Fichier CSV',
    codes: 'Codes des colis',
    codesHelp: 'Un colis par ligne : scannez les codes-barres ou collez des colonnes code, montant, frais.',
    drop: 'Choisir ou déposer un fichier CSV',
    dropHelp: 'Enregistrez le relevé du transporteur au format CSV. Le fichier est lu dans votre navigateur.',
    fileTooLarge: 'Ce fichier dépasse 2 Mo. Découpez le relevé en plusieurs fichiers.',
    nothingRead: 'Aucun code de colis lu. Collez des codes ou choisissez un fichier.',
    preview: 'Colis lus : {{count}}',
    invalidRows: 'Lignes ignorées car illisibles : {{rows}}',
    importedAt: 'Importé le',
    source: 'Source',
    source_paste: 'Collé ou scanné',
    source_csv: 'Fichier CSV',
    lines: 'Lignes',
    settled: 'Réglés',
    disputed: 'En litige',
    attention: 'À vérifier',
    none: 'Aucun relevé importé',
    noneHelp: 'Importez le relevé de versement d’un transporteur pour régler les colis livrés.',
    detailTitle: 'Relevé importé',
    detailTitleOf: 'Relevé du {{date}}',
    detailContext: 'Le résultat de chaque ligne du relevé. Les litiges se règlent depuis la finance.',
    back: 'Retour aux relevés',
    trackingNumber: 'N° de suivi',
    amount: 'Montant',
    fee: 'Frais',
    outcome: 'Résultat',
    kpi_lineCount: 'Lignes',
    kpi_settledCount: 'Réglés',
    kpi_disputedCount: 'En litige',
    kpi_attentionCount: 'À vérifier',
    view: 'Afficher',
    view_all: 'Tout',
    view_attention: 'À vérifier',
    view_disputed: 'Litiges',
    view_settled: 'Réglés',
    noLines: 'Aucune ligne dans cette vue',
    outcome_settled: 'Réglé',
    outcome_return_fee: 'Frais de retour',
    outcome_disputed: 'Montant différent',
    outcome_duplicate: 'Déjà réglé',
    outcome_not_delivered: 'Pas encore livré',
    outcome_unknown: 'Colis inconnu',
    outcome_wrong_carrier: 'Autre transporteur',
  },
  parcels: {
    returnedTitle: 'Colis retournés',
    returnedContext_one: '{{count}} colis en retour, retourné ou réceptionné',
    returnedContext_other: '{{count}} colis en retour, retournés ou réceptionnés',
    missingTitle: 'Colis manquants',
    missingContext_one: '{{count}} colis chez le transporteur, toujours pas livré après le délai prévu',
    missingContext_other: '{{count}} colis chez le transporteur, toujours pas livrés après le délai prévu',
    searchLabel: 'Chercher un colis',
    searchPlaceholder: 'Code-barres, n° de commande ou téléphone',
    returnedSince: 'Retour depuis',
    createdSince: 'Créée',
    receive: 'Réceptionner des retours',
    returnedEmpty: 'Aucun colis retourné',
    returnedEmptyHelp: 'Les colis que le transporteur renvoie apparaissent ici.',
    missingEmpty: 'Aucun colis manquant',
    missingEmptyHelp:
      'Un colis apparaît ici quand il est chez le transporteur et toujours pas livré après le délai prévu.',
    noMatch: 'Aucun colis ne correspond',
    noMatchHelp: 'Modifiez la recherche ou effacez les filtres.',
  },
  returns: {
    searchLabel: 'Chercher un retour',
    searchPlaceholder: 'Code-barres, n° de commande ou téléphone',
    reported: 'Signalé',
    toReceiveNoMatch: 'Aucun colis ne correspond',
    context:
      'Scannez les colis revenus au dépôt (code-barres, n° de commande ou téléphone du client), puis réceptionnez-les en une fois : les articles intacts reviennent en stock, les articles endommagés en sortent.',
    suggestionsTitle: 'Colis correspondants',
    suggestionsCount_one: '{{count}} colis correspond',
    suggestionsCount_other: '{{count}} colis correspondent',
    noSuggestion: 'Aucun colis ne correspond',
    searching: 'Recherche…',
    inBasket: 'Déjà dans la liste',
    notReceivableShort: 'Pas encore réceptionnable',
    scanLabel: 'Code du colis',
    scanHelp: 'Code-barres, numéro de suivi, numéro de commande ou téléphone du client.',
    find: 'Chercher',
    added: 'Colis {{number}} ajouté.',
    notFound: '{{code}} : aucun colis trouvé.',
    alreadyScanned: 'Colis {{number}} déjà dans la liste.',
    notReceivable: 'Colis {{number}} : il ne peut pas être réceptionné (statut : {{status}}).',
    chooseTitle: 'Colis trouvés',
    chooseHelp: 'Plusieurs colis correspondent ({{count}}) : choisissez celui qui est revenu.',
    basketTitle: 'Colis scannés ({{count}})',
    basketEmpty: 'Scannez un colis ou ajoutez-le depuis la liste « À réceptionner ».',
    parcel: 'Colis {{number}}',
    articles: 'articles : {{count}}',
    notAnnounced: 'Pas encore signalé en retour par {{carrier}}',
    markDamaged: 'Endommagés ?',
    damagedCount: 'Endommagés : {{count}}',
    remove: 'Retirer le colis {{number}}',
    quantity: 'Qté : {{count}}',
    damaged: 'Endommagés',
    damagedInvalid: 'Saisissez un nombre entier entre 0 et {{max}}.',
    restock: 'Remis en stock : {{count}}',
    receiveAll: 'Réceptionner {{count}} colis',
    receiving: 'Réception…',
    receivedCount: 'Réceptionnés : {{count}} · refusés : {{refused}}',
    confirmTitle: 'Colis pas encore signalés en retour : {{count}}',
    confirmMessage:
      '{{numbers}} : le transporteur ne les a pas encore signalés en retour. Confirmez qu’ils sont bien revenus au dépôt.',
    confirmCancel: 'Vérifier d’abord',
    toReceiveTitle: 'À réceptionner ({{count}})',
    toReceiveHelp: 'Colis que le transporteur a signalés en retour et qui ne sont pas encore réceptionnés.',
    toReceiveEmpty: 'Aucun colis en attente de réception.',
    addAll: 'Tout ajouter ({{count}})',
    add: 'Ajouter le colis {{number}}',
    addShort: 'Ajouter',
    received: 'Colis {{number}} réceptionné · remis en stock : {{restocked}} · endommagés : {{damaged}}',
    sessionTitle: 'Réceptionnés pendant cette session',
    sessionEmpty: 'Aucun colis réceptionné pour l’instant.',
  },
  handover: {
    searchLabel: 'Chercher une remise',
    searchPlaceholder: 'N° de suivi ou de commande d’un colis',
    noMatch: 'Aucune remise ne correspond',
    noMatchHelp: 'Changez la recherche ou effacez les filtres.',
    context: 'Scannez les colis remis au livreur, puis imprimez le bon de sortie à faire signer.',
    startTitle: 'Nouvelle remise',
    noCarrier: 'Aucun transporteur n’est configuré. Configurez-en un dans Paramètres.',
    carrier: 'Transporteur',
    start: 'Commencer la remise',
    history: 'Remises récentes',
    openedAt: 'Ouverte le',
    status: 'Statut',
    status_open: 'En cours',
    status_closed: 'Clôturée',
    count: 'Colis',
    total: 'À encaisser',
    voucher: 'Bon de sortie',
    downloadVoucher: 'Télécharger le bon de sortie',
    voucherDownloaded: 'Bon de sortie téléchargé',
    none: 'Aucune remise pour l’instant',
    noneHelp: 'Commencez une remise pour scanner les colis confiés au livreur.',
    scanLabel: 'N° de suivi ou de commande',
    scanHelp:
      'Scannez l’étiquette ou tapez un numéro : la liste des colis prêts se filtre, Entrée ajoute le colis.',
    add: 'Ajouter',
    addParcel: 'Ajouter le colis {{trackingNumber}}',
    readyTitle: 'Colis prêts à remettre',
    readyNone: 'Aucun colis n’attend ce transporteur.',
    readyNoMatch: 'Aucun colis prêt ne correspond à « {{search}} ».',
    accepted: '{{trackingNumber}} remis au transporteur',
    back: 'Toutes les remises',
    countValue: '{{count}} colis',
    trackingNumber: 'N° de suivi',
    order: 'Commande',
    recipient: 'Destinataire',
    phone: 'Téléphone',
    place: 'Destination',
    amount: 'Montant',
    empty: 'Aucun colis scanné',
    emptyHelp: 'Scannez le premier colis pour commencer.',
    close: 'Clôturer et imprimer le bon de sortie',
    closeTitle: 'Clôturer la remise ?',
    closeMessage:
      '{{count}} colis seront inscrits sur le bon de sortie de {{carrier}}. La remise ne pourra plus être modifiée.',
    closeConfirm: 'Clôturer la remise',
    refused_closed: 'Cette remise est clôturée.',
    refused_wrong_carrier: 'Ce colis est confié à un autre transporteur.',
    refused_not_ready: 'Ce colis n’attend pas d’enlèvement (déjà enlevé, annulé ou pas encore enregistré).',
    refused_empty: 'Scannez au moins un colis avant de clôturer.',
    refused_currency: 'Ce colis n’est pas dans la même devise que la remise.',
  },
  sender: {
    taxIdLine: 'Matricule fiscal : {{value}}',
    taxIdMissing: 'Matricule fiscal non renseigné (facultatif)',
    previewLabel: 'Aperçu de l’étiquette',
    previewCaption: 'Expéditeur',
    sectionContext:
      'Le bloc « Expéditeur » imprimé sur chaque étiquette de colis (Mylerz, Al Amana, transporteur de test).',
    sectionTitle: 'Étiquettes',
    title: 'Expéditeur',
    help: 'Ces informations apparaissent dans le bloc « Expéditeur » de chaque étiquette.',
    name: 'Nom de la boutique',
    phone: 'Téléphone',
    address: 'Adresse',
    taxId: 'Matricule fiscal ou CIN',
    taxIdHelp: 'Facultatif.',
    fieldRequired: 'Ce champ est obligatoire.',
    saved: 'Expéditeur enregistré',
    fill: 'Renseigner l’expéditeur',
    edit: 'Modifier',
    none: 'Aucun expéditeur',
    noneHelp: 'Renseignez-le pour pouvoir imprimer les étiquettes.',
  },
  carriers: {
    customerFee: 'Frais de livraison facturés au client',
    customerFeeHelp:
      'Montant fixe par colis facturé au client : il détermine les frais de livraison des commandes expédiées avec ce transporteur.',
    customerFeeInvalid: 'Saisissez un montant positif avec au plus 3 décimales.',
    customerFeeShown: 'Frais client : {{fee}}',
    connectedCount: 'Connectés : {{count}} sur {{total}}',
    secretHint: 'Identifiants chiffrés, se terminant par',
    changeCredentials: 'Changer les identifiants',
    connect: 'Connecter',
    state_soonHelp: 'Cette intégration arrive prochainement.',
    state_soon: 'Bientôt disponible',
    state_notConnectedHelp: 'Saisissez les identifiants fournis par le transporteur.',
    state_notConnected: 'Non connecté',
    state_pausedHelp: 'Envois suspendus. Les identifiants sont conservés.',
    state_paused: 'En pause',
    state_connectedHelp: 'Vous pouvez expédier vos colis avec ce transporteur.',
    state_connected: 'Connecté',
    title: 'Transporteurs',
    context:
      'Les sociétés de livraison qui enlèvent vos colis. Connectez celles avec qui vous avez un contrat.',
    carrier: 'Transporteur',
    none: 'Aucun transporteur disponible',
    accountTitle: 'Compte {{carrier}}',
    accountHelpNew: 'Saisissez les identifiants fournis par le transporteur.',
    accountHelpReplace:
      'Les identifiants actuels ne sont jamais réaffichés. Saisissez-les à nouveau pour les remplacer.',
    fieldRequired: 'Ce champ est obligatoire.',
    enabled: 'Utiliser ce compte pour les expéditions',
    enabledHelp: 'Désactivez-le pour suspendre les envois sans perdre les identifiants.',
    saved: 'Compte {{carrier}} enregistré',
    field_apiKey: 'Clé d’API',
    field_username: 'Identifiant',
    field_password: 'Mot de passe',
    field_token: 'Jeton',
    field_userId: 'Identifiant client',
    field_warehouseName: 'Entrepôt d’enlèvement',
    field_parcelType: 'Type de colis',
  },
  table: {
    previous: 'Précédent',
    next: 'Suivant',
    range: '{{from}}–{{to}} sur {{total}}',
  },
} as const;
